/* ===== pxl-drawer-tweaks : script 3 ===== */
(function () {
    var ALMA_MAX = PXL_CFG.alma_max * 100;
    var ALMA_MIN = 50 * 100;
    var FREE_MIN = 50 * 100;
    var ALMA_LOGO = '<span class="pxl-a-logo" role="img" aria-label="Alma"><svg viewBox="0 0 360 109" aria-hidden="true" focusable="false"><path fill="#FA5022" d="M333.24 28.3462V38.4459C327.504 31.1018 319.176 26.5132 309.288 26.5132C290.208 26.5132 275.424 43.5497 275.424 64.5757C275.424 85.6018 290.208 102.638 309.288 102.638C319.872 102.638 328.668 97.3908 334.416 89.1241V100.817H352.668V28.3462H333.24ZM314.028 84.4876C303.42 84.4876 294.828 75.574 294.828 64.5757C294.828 53.5775 303.42 44.6639 314.028 44.6639C324.636 44.6639 333.228 53.5775 333.228 64.5757C333.228 75.574 324.636 84.4876 314.028 84.4876ZM109.5 8.23073H128.916V100.805H109.5V8.23073ZM151.248 59.7356C151.248 39.8117 163.5 26.5252 180.468 26.5252C191.004 26.5252 199.332 31.1976 204.348 39.1648C209.376 31.1976 217.692 26.5252 228.228 26.5252C245.196 26.5252 257.448 39.8117 257.448 59.7356V100.817H238.032V57.639C238.032 49.8635 232.872 44.7957 226.044 44.7957C219.216 44.7957 214.056 49.8755 214.056 57.639V100.817H194.64V57.639C194.64 49.8635 189.48 44.7957 182.652 44.7957C175.824 44.7957 170.664 49.8755 170.664 57.639V100.817H151.248V59.7356ZM74.34 29.101C69.744 11.9088 60.0241 6.40967 50.772 6.40967C41.5201 6.40967 31.8 11.9088 27.204 29.101L7.24805 100.829H26.916C30.12 88.8485 39.996 82.1753 50.772 82.1753C61.548 82.1753 71.424 88.8605 74.6281 100.829H94.3081L74.34 29.101ZM50.772 65.4623C44.508 65.4623 38.8321 67.8345 34.6441 71.6803L45.924 29.9397C47.0041 25.9501 48.6001 24.6802 50.784 24.6802C52.9681 24.6802 54.5641 25.9501 55.6441 29.9397L66.912 71.6803C62.724 67.8345 57.036 65.4623 50.772 65.4623Z"/></svg></span>';
    var ICO_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/></svg>';
    var ICO_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
    /* Tarifs Shopify : Chronopost 7,90 €, Colissimo 4,99 €, offerts dès 50 € */
    var CARRIERS = {
      'Livraison Chronopost': { t: 'Livraison Express', free: 'GRATUIT', price: '7,90 €', ico: '', img: '<img class="pxl-car-logo" src="' + PXL_CFG.cp_logo + '&width=160" alt="Chronopost" width="70" height="16">' },
      'Colissimo': { t: 'Livraison Standard', free: 'GRATUIT', price: '4,99 €', ico: ICO_BOX, img: '<img class="pxl-car-logo" src="' + PXL_CFG.cs_logo + '" alt="Colissimo" width="62" height="16">' },
      'Mondial Relay': { t: 'Livraison en Point Relais', free: 'GRATUITE', price: 'offerte dès 50 €', ico: ICO_PIN, img: '<img class="pxl-car-logo pxl-car-logo--mr" src="' + PXL_CFG.mr_logo + '&width=160" alt="Mondial Relay" width="56" height="22">' }
    };

    function money(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function parseCents(txt) {
      var m = (txt || '').replace(/\s/g, '').match(/([\d.]+),(\d{2})/);
      if (!m) return null;
      return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.pxl-a-tab') : null;
      if (!t) return;
      e.preventDefault();
      /* chaque groupe (Alma, PayPal) a ses propres onglets */
      var box = t.closest('.pxl-a-pp') || t.closest('.pxl-a-alma') || t.closest('.pxl-split');
      var n = t.getAttribute('data-n');
      box.querySelectorAll(':scope > .pxl-a-tabs > .pxl-a-tab, :scope > .pxl-a-panel').forEach(function (el) {
        el.classList.toggle('is-on', el.getAttribute('data-n') === n);
      });
    }, true);

    function apply(root) {
      if (!root) return;

      /* 2. code promo sous Commander (ordinateur) */
      if (!window.matchMedia('(max-width: 750px)').matches) {
        var promo = root.querySelector('.pxm-cpromo');
        var go = root.querySelector('.pxm-cgo');
        if (promo && go && go.nextElementSibling !== promo) go.parentNode.insertBefore(promo, go.nextSibling);
      }

      /* 4. mensualités sous le sous-total */
      var tot = root.querySelector('.pxm-ctot');
      if (tot) {
        var cents = parseCents(tot.textContent);
        var old = root.querySelector('.pxl-split');
        if (cents && old && old.dataset.cents === String(cents)) {
          /* rien à refaire */
        } else {
        if (old) old.remove();
        if (cents) {
          var line = document.createElement('div');
          line.className = 'pxl-split';
          var c3 = Math.floor(cents / 3), c4 = Math.floor(cents / 4), c10 = Math.floor(cents / 10);
          var fee10 = Math.floor(cents * 727 / 10000);
          var pp4 = cents >= 3000 && cents <= 200000, pp24 = cents >= 12000 && cents <= 290000;
          var almaOk = cents >= ALMA_MIN && cents <= ALMA_MAX;
          var ppHtml = '';
          if (pp4 || pp24) {
            var legal = '<span class="pxl-a-legal">Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.</span>';
            var ppOn = pp4 ? '4' : '24';
            var tabs = '', panels = '';
            if (pp4) {
              tabs += '<button type="button" class="pxl-a-tab' + (ppOn === '4' ? ' is-on' : '') + '" data-n="4">4x <small>sans frais</small></button>';
              panels += '<div class="pxl-a-panel' + (ppOn === '4' ? ' is-on' : '') + '" data-n="4"><span class="pxl-a-amt"><b>4 ×</b> ' + money(c4) + '</span><span class="pxl-a-sub"><em>Sans frais</em> · 1<sup>re</sup> échéance aujourd’hui</span></div>';
            }
            if (pp24) {
              [6, 12, 24].forEach(function (k) {
                var on = String(k) === ppOn ? ' is-on' : '';
                tabs += '<button type="button" class="pxl-a-tab' + on + '" data-n="' + k + '">' + k + 'x</button>';
                panels += '<div class="pxl-a-panel' + on + '" data-n="' + k + '"><span class="pxl-a-amt"><b>' + k + ' ×</b> ' + money(Math.floor(cents / k)) + '<small> hors intérêts</small></span><span class="pxl-a-sub">Intérêts et TAEG selon votre profil, affichés par PayPal avant validation</span>' + legal + '</div>';
              });
            }
            ppHtml = '<div class="pxl-a-pp"><div class="pxl-a-head"><span>' + (almaOk ? 'Ou' : 'Réglez') + ' <strong>' + (pp4 ? 'en 4x sans frais' : 'jusqu’en 24x') + '</strong> avec PayPal</span><span class="pxl-a-logo pxl-a-logo--pp" aria-label="PayPal">PayPal</span></div>' +
              '<div class="pxl-a-tabs" role="tablist">' + tabs + '</div>' + panels + '</div>';
          }
          if (cents >= ALMA_MIN && cents <= ALMA_MAX) {
            line.innerHTML =
              '<div class="pxl-a-head"><span>Réglez en <strong>4x sans frais</strong></span>' + ALMA_LOGO + '</div>' +
              '<div class="pxl-a-tabs" role="tablist">' +
                '<button type="button" class="pxl-a-tab" data-n="3">3x</button>' +
                '<button type="button" class="pxl-a-tab is-on" data-n="4">4x <small>sans frais</small></button>' +
                '<button type="button" class="pxl-a-tab" data-n="10">10x</button>' +
              '</div>' +
              '<div class="pxl-a-panel" data-n="3"><span class="pxl-a-amt"><b>3 ×</b> ' + money(c3) + '</span><span class="pxl-a-sub"><em>Sans frais</em> · aucun coût supplémentaire</span></div>' +
              '<div class="pxl-a-panel is-on" data-n="4"><span class="pxl-a-amt"><b>4 ×</b> ' + money(c4) + '</span><span class="pxl-a-sub"><em>Sans frais</em> · aucun coût supplémentaire</span></div>' +
              '<div class="pxl-a-panel" data-n="10"><span class="pxl-a-amt"><b>10 ×</b> ' + money(c10) + '</span><span class="pxl-a-sub">1<sup>er</sup> versement ' + money(c10 + fee10) + ' (frais inclus) · Frais ' + money(fee10) + ' · Coût total ' + money(cents + fee10) + '</span><span class="pxl-a-legal">Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.</span></div>' +
              ppHtml +
              '<div class="pxl-a-mini"><span>ou <strong>4× ' + money(c4) + '</strong> sans frais</span>' + ALMA_LOGO + '</div>';
          } else if (ppHtml) {
            line.innerHTML = ppHtml +
              (pp4 ? '<div class="pxl-a-mini"><span>ou <strong>4× ' + money(c4) + '</strong> sans frais</span><span class="pxl-a-logo pxl-a-logo--pp" aria-label="PayPal">PayPal</span></div>' : '');
            line.classList.add('pxl-split--pp');
          }
          line.dataset.cents = String(cents);
          if (line.innerHTML) tot.parentNode.insertBefore(line, tot.nextSibling);
        }
        }
      }

      /* 4b. logos de paiement au-dessus de Commander */
      var go2 = root.querySelector('.pxm-cgo');
      var tpl = document.getElementById('pxl-pay-icons');
      if (go2 && tpl && !(go2.previousElementSibling && go2.previousElementSibling.classList.contains('pxl-pay'))) {
        var oldPay = root.querySelector('.pxl-pay');
        if (oldPay) oldPay.remove();
        var pay = document.createElement('div');
        pay.className = 'pxl-pay';
        pay.innerHTML = '<span class="pxl-pay-t"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Paiement 100 % sécurisé</span><span class="pxl-pay-icons">' + tpl.innerHTML + '</span>';
        go2.parentNode.insertBefore(pay, go2);
      }

      /* 12. en-tête « Mon panier » */
      var ttl = root.querySelector('.pxm-ctitle');
      if (ttl && ttl.firstChild && ttl.firstChild.nodeType === 3 && /votre panier/i.test(ttl.firstChild.nodeValue)) {
        ttl.firstChild.nodeValue = ttl.firstChild.nodeValue.replace(/votre panier/i, 'Mon panier');
      }

      /* 15. suggestions ciblées (produits compatibles) */
      applySug(root);

      /* 5. message positif */
      var sum = root.querySelector('.pxm-csum');
      if (sum && !sum.dataset.pxl && /sur commande/i.test(sum.textContent)) {
        sum.dataset.pxl = '1';
        sum.innerHTML = '<b>Une partie de votre panier est en préparation.</b> Retirez tout en une fois, ou récupérez dès maintenant ce qui est en rayon : à vous de choisir ci-dessous.';
      }

      /* 6. titre suggestions */
      root.querySelectorAll('.pxm-sgt').forEach(function (h) {
        if (/suggestions/i.test(h.textContent)) h.textContent = 'Complétez votre commande';
      });

      /* 10. Lignes transporteurs (GRATUIT dès 50 €, sinon prix) */
      var totEl = root.querySelector('.pxm-ctot');
      var totCents = totEl ? parseCents(totEl.textContent) : null;
      var isFree = totCents !== null && totCents >= FREE_MIN;
      root.querySelectorAll('.pxm-cfin p').forEach(function (p) {
        var l = p.querySelector('.pxm-l');
        if (!l) return;
        var key = l.dataset.pxlCar || l.textContent.trim();
        var c = CARRIERS[key];
        if (!c) return;
        if (l.dataset.pxlCar !== key || l.dataset.pxlFree !== String(isFree)) {
          l.dataset.pxlCar = key;
          l.dataset.pxlFree = String(isFree);
          l.innerHTML = '<span class="pxl-car"><span class="pxl-car-t"><span class="pxl-car-n">' + c.t + '</span> ' +
            (isFree ? '<em class="pxl-free">' + c.free + '</em>' : '<em class="pxl-price">' + c.price + '</em>') +
            '</span>' + c.img + '</span>';
        }
        if (!p.classList.contains('pxl-car-row')) {
          p.classList.remove('is-sub');
          p.classList.add('pxl-car-row');
          if (c.ico && !p.querySelector(':scope > svg')) p.insertAdjacentHTML('afterbegin', c.ico);
          var last = p.lastElementChild;
          if (last && last !== l) last.classList.add('pxl-car-date');
        }
      });

      /* 9. mobile : le message, le choix de retrait et le code promo défilent avec les articles ;
            seul le sous-total + Commander reste figé en bas (le bloc re-rend son HTML à chaque
            mise à jour du panier, d'où le déplacement systématique) */
      if (window.matchMedia('(max-width: 750px)').matches) {
        var list = root.querySelector('.pxm-clist');
        if (list) {
          var sum2 = root.querySelector('.pxm-csum');
          if (sum2 && sum2.parentNode !== list) list.insertBefore(sum2, list.firstChild);
          var fin2 = root.querySelector('.pxm-cfin');
          var msug = list.querySelector('.pxm-msug');
          if (fin2 && fin2.parentNode !== list) list.insertBefore(fin2, msug || null);
          var pr = root.querySelector('.pxm-cpromo');
          if (pr && (pr.parentNode !== list || (function () { var x = list.lastElementChild; while (x && x !== pr && /\bpxw-/.test(x.className)) x = x.previousElementSibling; return x !== pr; })())) list.appendChild(pr);
        }
      }

      /* 7. état ouvert */
      document.body.classList.toggle('pxl-drawer-open', root.classList.contains('active'));
    }

    /* 15. Produits compatibles : suggestions ciblées par type d'article (remplace les
          « related » génériques de Shopify, qui proposaient une Xbox pour une carte graphique).
          Chaque règle : motif sur « type + titre » → collections à piocher, dans l'ordre. */
    var LIC = [
      [/pok[eé]mon|pikachu|[eé]voli|dracaufeu|ectoplasma|team rocket/i, 'pokemon'],
      [/naruto|shipp?uden|akatsuki|konoha/i, 'naruto'], [/one piece|luffy|zoro|chopper/i, 'one-piece'],
      [/demon slayer|kimetsu|tanjiro|nezuko/i, 'demon-slayer'], [/zelda|link\b|triforce/i, 'zelda'],
      [/mario|luigi|yoshi|bowser|peach/i, 'super-mario-bros'], [/sonic|tails|knuckles|shadow/i, 'sonic'],
      [/hello kitty|sanrio|kuromi|cinnamoroll/i, 'hello-kitty'], [/dragon ball|goku|vegeta|saiyan/i, 'dragon-ball'],
      [/jujutsu|gojo|sukuna/i, 'jujutsu-kaisen'], [/fullmetal|alchemist|elric/i, 'fullmetal-alchemist'],
      [/stitch/i, 'stitch'], [/harry potter|poudlard|hogwarts/i, 'harry-potter'], [/pat.?patrouille|paw patrol/i, 'patpatrouille'],
      [/dandadan/i, 'dandadan'], [/bleach/i, 'bleach'], [/fortnite/i, 'fortnite'], [/marvel|spider|avengers|iron man|hulk/i, 'marvel'],
      [/batman|joker|superman|dc comics/i, 'dc-comics'], [/disney|princess|villain/i, 'disney'], [/minecraft/i, 'minecraft']
    ];
    var LIC_COLS = {
      'pokemon': ['figurine-pokemon', 'peluche-pokemon', 'porte-cles-pokemon', 'booster-pokemon'],
      'naruto': ['figurine-naruto-shippuden', 'peluche-naruto', 'porte-cles-naruto'],
      'one-piece': ['figurine-one-piece', 'peluche-one-piece', 'porte-cles-one-piece'],
      'demon-slayer': ['figurine-demon-slayer', 'porte-cles-demon-slayer', 'grille-ventilateur-demon-slayer'],
      'zelda': ['figurine-zelda', 'peluche-zelda', 'porte-cles-zelda', 'bricks-zelda'],
      'super-mario-bros': ['figurine-super-mario-bros', 'peluche-super-mario-bros', 'porte-cles-super-mario-bros'],
      'sonic': ['figurine-sonic-orleans', 'peluche-sonic', 'porte-cles-sonic'],
      'hello-kitty': ['peluches-hello-kitty', 'figurine-hello-kitty', 'porte-cles-hello-kitty', 'bricks-hello-kitty'],
      'dragon-ball': ['porte-cles-dragon-ball', 'dragon-ball-z'],
      'jujutsu-kaisen': ['figurine-jujutsu-kaisen', 'peluche-jujutsu-kaisen', 'porte-cles-jujutsu-kaisen'],
      'fullmetal-alchemist': ['figurine-fullmetal-alchemist', 'fullmetal-alchemist'],
      'stitch': ['peluche-stitch', 'porte-cles-disney'], 'harry-potter': ['figurine-harry-potter', 'porte-cles-harry-potter'],
      'patpatrouille': ['figurines-patpatrouille', 'peluche-patpatrouille', 'sac-a-dos-patpatrouille'],
      'dandadan': ['figurine-dandadan', 'dandadan'], 'bleach': ['figurine-bleach', 'bleach'], 'fortnite': ['figurine-fortnite', 'peluche-fortnite'],
      'marvel': ['figurine-marvel', 'porte-cles-marvel'], 'dc-comics': ['figurine-dc-comics-1', 'porte-cles-dc-comics'],
      'disney': ['figurine-disney-princess', 'porte-cles-disney', 'peluche-stitch'], 'minecraft': ['minecraft']
    };
    var RULES = [
      [/^cartes? graphiques?/i, ['support-gpu', 'supporte-gpu-custom', 'alimentation-850w', 'alimentation-750w', 'pate-thermiques']],
      [/^processeurs?/i, ['ventirads', 'watercooling-aio', 'pate-thermiques', 'ram-ddr5']],
      [/^cartes? m[eè]res?/i, ['ram-ddr5', 'ram-ddr4', 'disques-durs-nvme', 'processeurs']],
      [/^(m[eé]moire )?ram\b/i, ['disques-durs-nvme', 'ventirads', 'pate-thermiques']],
      [/^disques? durs?/i, ['memoires-ram', 'cables-pour-disque-dur', 'disques-durs-nvme']],
      [/^alimentation pc/i, ['cable-managing', 'cables-internes', 'ventilateurs-boitier']],
      [/^bo[iî]tiers? pc/i, ['ventilateurs-boitier', 'eclairage-argb', 'grille-pour-ventilateur', 'alimentation-psu']],
      [/^(ventirads?|watercooling|ventilateurs?|dissipateur|p[aâ]te thermique)/i, ['pate-thermiques', 'ventilateurs-boitier', 'grille-pour-ventilateur']],
      [/^(pc gamer|pack pc|pc bureautique)/i, ['ecrans-gaming', 'claviers-gaming', 'souris-gaming', 'casque-gaming', 'tapis-de-souris-gaming']],
      [/^pc portable/i, ['souris-gaming-sans-fil', 'casque-gaming', 'tapis-de-souris-gaming', 'disques-durs-externes']],
      [/^moniteur/i, ['cables-video-hdmi-dp-dvi-vga', 'bras-decran', 'claviers-gaming', 'souris-gaming']],
      [/^claviers?/i, ['souris-gaming', 'tapis-de-souris-gaming', 'casque-gaming']],
      [/^souris/i, ['tapis-de-souris-gaming', 'claviers-gaming', 'casque-gaming']],
      [/^tapis de souris/i, ['souris-gaming', 'claviers-gaming']],
      [/^(casques?|microphones?|stream deck)/i, ['microphones-1', 'webcam-streaming', 'souris-gaming', 'claviers-gaming']],
      [/^(fauteuils?|bureau)/i, ['bureaux-gaming', 'fauteuils-gaming', 'tapis-de-souris-gaming']],
      [/^(consoles?|manettes?|accessoires pour consoles).*(ps5|playstation 5)/i, ['playstation-5', 'casques-gaming-ps5', 'manettes-controleurs-joysticks']],
      [/^(consoles?|manettes?|accessoires pour consoles).*(switch)/i, ['nintendo-switch', 'manettes-controleurs-joysticks']],
      [/^(consoles?|manettes?|accessoires pour consoles).*(xbox)/i, ['xbox-series', 'xbox', 'manettes-controleurs-joysticks']],
      [/^(consoles?|manettes?|accessoires pour consoles)/i, ['manettes-controleurs-joysticks', 'jeux-video-reconditionnes', 'cable-dalimentation-de-console']],
      [/^jeux? vid[eé]o.*(switch)/i, ['nintendo-switch', 'manettes-controleurs-joysticks']],
      [/^jeux? vid[eé]o.*(ps5|playstation 5)/i, ['playstation-5', 'casques-gaming-ps5']],
      [/^jeux? vid[eé]o.*(ps4|playstation 4)/i, ['playstation-4', 'manettes-controleurs-joysticks']],
      [/^jeux? vid[eé]o.*(xbox)/i, ['xbox', 'manettes-controleurs-joysticks']],
      [/^jeux? vid[eé]o/i, ['jeux-video-reconditionnes', 'manettes-controleurs-joysticks']],
      [/^(cartes pok[eé]mon|pok[eé]mon)/i, ['accessoires-cartes-pokemon', 'booster-pokemon', 'coffret-pokemon', 'tripack-pokemon']],
      [/^(jeux de soci[eé]t[eé]|jeu de cartes|uno|dobble|puzzles|jeux de construction)/i, ['jeux-de-societe', 'jeux-de-cartes', 'jeux-de-construction']],
      [/^(figurines?|peluches?|porte-cl[eé]s)/i, 'LICENCE']
    ];
    function sugCols(pt) {
      for (var i = 0; i < RULES.length; i++) {
        if (!RULES[i][0].test(pt)) continue;
        if (RULES[i][1] !== 'LICENCE') return RULES[i][1];
        for (var j = 0; j < LIC.length; j++) if (LIC[j][0].test(pt)) return LIC_COLS[LIC[j][1]] || null;
        return /^figurine/i.test(pt) ? ['figurines-geek', 'figurines'] : /^peluche/i.test(pt) ? ['peluches'] : ['porte-cles'];
      }
      return null;
    }
    var SUG_CACHE = {};
    function fetchCol(h) {
      if (!SUG_CACHE[h]) SUG_CACHE[h] = fetch('/collections/' + h + '/products.json?limit=12').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) { return d.products || []; }).catch(function () { return []; });
      return SUG_CACHE[h];
    }
    function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    /* lignes du panier → [{pid, pt}] ; renvoie jusqu'à 6 produits, en alternant les collections */
    function pickSug(lines) {
      var inCart = {}, cols = [], seen = {};
      var pts = lines.map(function (l) { return (l.pt || '').toLowerCase(); });
      /* un type « un seul suffit » déjà dans le panier (support GPU, alimentation…) n'est pas re-proposé ;
         cartes Pokémon, jeux, figurines : on peut en vouloir plusieurs */
      var ONE_OF = /^(support gpu|alimentation|ventirads?|watercooling|p[aâ]te thermique|dissipateur|bo[iî]tiers? pc|cartes? m[eè]res?|processeurs?|cartes? graphiques?|moniteur|claviers?|souris|tapis|casques?|fauteuils?|bureau|consoles?|pc |pack pc|microphones?|stream deck|webcam)/i;
      var sameType = function (p) { var ty = (p.product_type || '').toLowerCase(); return ty && ONE_OF.test(ty) && pts.some(function (s) { return s.indexOf(ty) === 0; }); };
      lines.forEach(function (l) { inCart[String(l.pid)] = 1; });
      /* ancres : les 2 articles les plus chers (le produit principal, pas le dernier accessoire ajouté) */
      var anchors = lines.slice().sort(function (a, b) { return (b.price || 0) - (a.price || 0); }).slice(0, 2);
      anchors.forEach(function (l) { (sugCols(l.pt) || []).forEach(function (h) { if (!seen[h]) { seen[h] = 1; cols.push(h); } }); });
      if (!cols.length) return Promise.resolve(null);
      return Promise.all(cols.map(fetchCol)).then(function (lists) {
        var out = [], used = {};
        lists = lists.map(function (ps) {
          return ps.filter(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            return v && !inCart[String(p.id)] && !sameType(p) && (p.images && p.images.length);
          });
        });
        for (var k = 0; k < 12 && out.length < 6; k++) {
          lists.forEach(function (ps) { var p = ps[k]; if (p && !used[p.id] && out.length < 6) { used[p.id] = 1; out.push(p); } });
        }
        return out.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          return { id: p.id, vid: v.id, title: p.title, url: '/products/' + p.handle, img: p.images[0].src, price: Math.round(parseFloat(v.price) * 100), cmp: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0 };
        });
      });
    }
    function addLine(vid, btn, after) {
      btn.disabled = true; btn.classList.add('is-done'); btn.textContent = btn.textContent.length > 2 ? 'Ajouté ✓' : '✓';
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(after)
        .catch(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.textContent = btn.textContent.length > 2 ? '+ Ajouter' : '+'; });
    }
    function sugCard(p, i, mobile) {
      var sale = p.cmp > p.price;
      var imgTag = '<img src="' + esc(p.img) + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">';
      if (mobile) return '<div class="pxm-msi"><a class="pxm-cth" href="' + esc(p.url) + '">' + imgTag + '</a><a class="pxm-cn" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="pxm-crow"><b class="pxm-cprice">' + money(p.price) + '</b><button type="button" class="pxm-sgadd" data-pxl-add="' + p.vid + '" aria-label="Ajouter ' + esc(p.title) + '">+</button></div></div>';
      return '<div class="pxm-sgi" style="animation-delay:' + (0.12 + i * 0.05) + 's"><a class="pxm-cth" href="' + esc(p.url) + '">' + imgTag + '</a><div class="pxm-cmeta"><a class="pxm-cn" href="' + esc(p.url) + '">' + esc(p.title) + '</a><p class="pxm-sgd is-ok">Disponible</p><div class="pxm-crow"><b class="pxm-cprice' + (sale ? '" style="color:var(--pink)' : '') + '">' + money(p.price) + '</b><button type="button" class="pxm-sgadd" data-pxl-add="' + p.vid + '">+ Ajouter</button></div></div></div>';
    }
    function applySug(root) {
      var mc = root.closest('[class*="mini-cart"], mini-cart-abjzzqlppuenpu2z3naigenblockb2128c6qgkpd4') || root.parentElement;
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pid]'));
      var lines = rows.map(function (r) { var pr = r.querySelector('.pxm-cprice'); return { pid: r.getAttribute('data-pid'), pt: r.getAttribute('data-pt') || '', price: pr ? (parseCents(pr.textContent) || 0) : 0 }; });
      var key = lines.map(function (l) { return l.pid; }).join(',');
      if (!key) return;
      var box = root.querySelector('[data-sug]'), mbox = root.querySelector('[data-msug]'), aside = root.querySelector('.pxm-csug');
      var render = function (list) {
        if (!list || !list.length) return;
        if (mc) mc._sugFor = lines[0].pid; /* le bloc ne relance pas ses « related » */
        if (box && box.getAttribute('data-pxl-sug') === key && mbox && mbox.getAttribute('data-pxl-sug') === key) return;
        if (box && box.getAttribute('data-pxl-sug') !== key) { box.setAttribute('data-pxl-sug', key); box.innerHTML = list.map(function (p, i) { return sugCard(p, i, false); }).join(''); if (aside) aside.hidden = false; }
        if (mbox && mbox.getAttribute('data-pxl-sug') !== key) { mbox.setAttribute('data-pxl-sug', key); mbox.innerHTML = '<p class="pxm-sgt">Complétez votre commande</p><div class="pxm-msrow">' + list.map(function (p, i) { return sugCard(p, i, true); }).join('') + '</div>'; }
      };
      if (root._pxlSugKey === key && root._pxlSugList) { render(root._pxlSugList); return; }
      if (root._pxlSugPending === key) return;
      root._pxlSugPending = key;
      pickSug(lines).then(function (list) {
        root._pxlSugPending = null;
        if (!list) { root._pxlSugKey = key; root._pxlSugList = null; return; } /* pas de règle : on laisse les suggestions du bloc */
        root._pxlSugKey = key; root._pxlSugList = list; render(list);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pxl-add]') : null;
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var mc = b.closest('[class*="mini-cart"], mini-cart-abjzzqlppuenpu2z3naigenblockb2128c6qgkpd4');
      addLine(b.getAttribute('data-pxl-add'), b, function () { if (mc && mc.refreshCart) mc.refreshCart(true); else location.reload(); });
    }, true);

    /* 15b. page /cart : bandeau « Complétez votre commande » sous les articles */
    function cartPageSug() {
      var items = document.querySelector('.cart .cart__items');
      if (!items || document.querySelector('.pxl-cart-sug')) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var lines = (c.items || []).map(function (it) { return { pid: it.product_id, pt: (it.product_type || '') + ' ' + (it.product_title || ''), price: it.price || 0 }; });
        return pickSug(lines);
      }).then(function (list) {
        if (!list || !list.length) return;
        var sec = document.createElement('section');
        sec.className = 'pxl-cart-sug';
        sec.setAttribute('aria-label', 'Complétez votre commande');
        sec.innerHTML = '<p class="pxl-cart-sug__t">Complétez votre commande</p><div class="pxl-cart-sug__row">' + list.slice(0, 4).map(function (p) {
          return '<div class="pxl-cart-sug__i"><a class="pxl-cart-sug__img" href="' + esc(p.url) + '"><img src="' + esc(p.img) + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" loading="lazy" width="120" height="120"></a><a class="pxl-cart-sug__n" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="pxl-cart-sug__b"><b>' + money(p.price) + '</b><button type="button" class="pxl-cart-sug__add" data-pxl-add="' + p.vid + '">+ Ajouter</button></div></div>';
        }).join('') + '</div>';
        items.appendChild(sec);
      }).catch(function () {});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cartPageSug); else cartPageSug();

    function root() { return document.querySelector('[class*="ai-minidrawer"]'); }

    var busy = false, timer = null;
    var mo = new MutationObserver(function () {
      if (busy) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var r = root();
        if (!r) return;
        busy = true;
        try { apply(r); } finally { busy = false; }
      }, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('DOMContentLoaded', function () { apply(root()); });
    apply(root());
  })();

/* ===== pxl-drawer-tweaks : script 9 ===== */
(function () {
    var PTS_EUR = PXL_CFG.pts_eur, PTS_REWARD = PXL_CFG.pts_reward, EUR_REWARD = PXL_CFG.eur_reward;
    var LOGGED = PXL_CFG.logged;
    var SAVED_URL = '/pages/mes-paniers';
    var REPRISE_URL = '/pages/estimation-reprise-a-distance';
    var KEY = 'pxl_saved_carts_v1';
    var REPRISE_RE = /(pc gamer|pc bureautique|pack pc|pc portable|cartes? graphiques?|processeurs?|cartes? m[eè]res?|m[eé]moire|\bram\b|disques?|consoles?|manettes?|bo[iî]tiers? pc|alimentation pc)/i;

    var ICO_STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/></svg>';
    var ICO_SWAP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/></svg>';
    var ICO_BOOK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12v18l-6-4-6 4z"/></svg>';
    var ICO_SHARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg>';
    var ICO_PDF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6v18h12V7z"/><path d="M14 3v4h4"/><path d="M9 13h6M9 17h6"/></svg>';

    function money(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function num(n) { return n.toLocaleString('fr-FR'); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function parseCents(txt) { var m = (txt || '').replace(/\s/g, '').match(/([\d.]+),(\d{2})/); return m ? parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10) : null; }
    function toast(html, ms) {
      var t = document.querySelector('.pxl-toast');
      if (!t) { t = document.createElement('div'); t.className = 'pxl-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.innerHTML = html; t.classList.add('is-on');
      clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, ms || 3200);
    }
    function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

    /* ---------- 1. fidélité ---------- */
    function fidHTML(cents) {
      var pts = Math.floor(cents / 100) * PTS_EUR;
      if (!pts) return '';
      var eur = Math.floor(pts / PTS_REWARD) * EUR_REWARD;
      var val = eur > 0 ? ', soit <b>' + eur + ' €</b> de remise sur un prochain achat' : ' (' + num(PTS_REWARD) + ' points = ' + EUR_REWARD + ' € de remise)';
      var sub = LOGGED ? '' : '<small><a href="/account/login">Connectez-vous</a> ou <a href="/account/register">créez votre compte</a> pour les cumuler.</small>';
      return ICO_STAR + '<span>Cette commande vous rapporte <b>' + num(pts) + ' points</b>' + val + '.' + sub + '</span>';
    }
    function putFid(anchor, cents, where) {
      if (!anchor) return;
      var el = anchor.parentNode.querySelector(':scope > .pxl-fid');
      var html = fidHTML(cents);
      if (!html) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement('div'); el.className = 'pxl-fid'; }
      if (el.getAttribute('data-c') !== String(cents)) { el.setAttribute('data-c', String(cents)); el.innerHTML = html; }
      if (where === 'after' && anchor.nextElementSibling !== el) anchor.parentNode.insertBefore(el, anchor.nextSibling);
    }

    /* ---------- 2. reprise ---------- */
    function repHTML() {
      return ICO_SWAP + '<span><strong>Une ancienne carte, console ou un PC ?</strong>Faites-le estimer à distance et économisez sur votre achat.</span><em>Estimer</em>';
    }
    function putRep(parent, before, show) {
      if (!parent) return;
      var el = parent.querySelector(':scope > .pxl-rep');
      if (!show) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement('a'); el.className = 'pxl-rep'; el.href = REPRISE_URL; el.innerHTML = repHTML(); }
      if (before) { if (before !== el && el.nextElementSibling !== before) parent.insertBefore(el, before); }
      else if (parent.lastElementChild !== el) parent.appendChild(el);
    }

    /* ---------- 3. paniers enregistrés ---------- */
    function loadSaved() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
    function storeSaved(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 30))); } catch (e) { toast('Impossible d’enregistrer sur cet appareil (navigation privée ?).'); } refreshCount(); }
    function itemsFromCart(c) {
      return (c.items || []).map(function (it) {
        return { h: it.handle, v: it.variant_id, q: it.quantity, t: it.product_title + (it.variant_title && it.variant_title !== 'Default Title' && it.variant_title !== 'Default' ? ' – ' + it.variant_title : ''), i: it.image || '', p: it.final_price, u: it.url || ('/products/' + it.handle) };
      });
    }
    function totalOf(items) { return items.reduce(function (s, it) { return s + it.p * it.q; }, 0); }
    function shareURL(entry) {
      var p = entry.items.map(function (it) { return it.h + '*' + it.v + '*' + it.q; }).join(',');
      return location.origin + SAVED_URL + '?p=' + encodeURIComponent(p) + (entry.name ? '&n=' + encodeURIComponent(entry.name) : '');
    }
    function refreshCount() {
      var n = loadSaved().length;
      document.querySelectorAll('.pxl-sv-ico b').forEach(function (b) { var v = n ? String(n) : ''; if (b.textContent !== v) b.textContent = v; });
    }
    function addAll(items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items.map(function (it) { return { id: it.v, quantity: it.q }; }) }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add'); }); return r.json(); });
    }
    function doShare(entry) {
      var url = shareURL(entry);
      var title = 'Mon panier Pixel 404' + (entry.name ? ' – ' + entry.name : '');
      var text = title + ' : ' + entry.items.length + ' article' + (entry.items.length > 1 ? 's' : '') + ', ' + money(totalOf(entry.items));
      if (navigator.share) { navigator.share({ title: title, text: text, url: url }).catch(function () {}); return; }
      var done = function () { toast('Lien copié. <a href="https://wa.me/?text=' + encodeURIComponent(text + ' ' + url) + '" target="_blank" rel="noopener">WhatsApp</a><a href="mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(text + '\n' + url) + '">E-mail</a>', 6000); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copiez ce lien :', url); });
      else window.prompt('Copiez ce lien :', url);
    }
    function doPDF(entry, w) {
      w = w || window.open('', '_blank');
      if (!w) { toast('Autorisez les fenêtres pour générer le PDF.'); return; }
      var tot = totalOf(entry.items);
      var d = new Date(entry.date || Date.now());
      var rows = entry.items.map(function (it) {
        return '<tr><td class="im">' + (it.i ? '<img src="' + esc(it.i) + (it.i.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '') + '</td><td>' + esc(it.t) + '</td><td class="c">' + it.q + '</td><td class="r">' + money(it.p) + '</td><td class="r"><b>' + money(it.p * it.q) + '</b></td></tr>';
      }).join('');
      var four = tot >= 5000 && tot <= 400000 ? '<p>Paiement en <b>4x sans frais</b> avec Alma : <b>4 × ' + money(Math.floor(tot / 4)) + '</b> (de 50 € à 4 000 €). Aussi en 3x sans frais, 10x, et avec PayPal.</p>' : (tot >= 3000 && tot <= 200000 ? '<p>Paiement en <b>4x sans frais</b> avec PayPal : <b>4 × ' + money(Math.floor(tot / 4)) + '</b>.</p>' : '');
      var pts = Math.floor(tot / 100) * PTS_EUR;
      var html = '<!doctype html><html lang="fr"><he'+'ad><meta charset="utf-8"><title>Panier Pixel 404' + (entry.name ? ' – ' + esc(entry.name) : '') + '</title>' +
        '<style>@page{margin:14mm}*{box-sizing:border-box}body{font-family:Outfit,system-ui,-apple-system,Segoe UI,sans-serif;color:#16151c;margin:0;font-size:12.5px}' +
        '.hd{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #7c3aed;padding-bottom:12px;margin-bottom:16px}' +
        '.lg{font-size:24px;font-weight:800;letter-spacing:.28em}.lg span{color:#7c3aed;font-size:13px;letter-spacing:0}.ad{text-align:right;font-size:11.5px;line-height:1.45;color:#4a4658}' +
        'h1{font-size:18px;margin:0 0 4px}.meta{color:#6f6a80;margin:0 0 14px}table{width:100%;border-collapse:collapse}th{text-align:left;font-size:10.5px;letter-spacing:.1em;text-transform:uppercase;color:#6f6a80;border-bottom:1px solid #ddd;padding:6px}' +
        'td{padding:8px 6px;border-bottom:1px solid #eee;vertical-align:middle}.im{width:56px}.im img{width:48px;height:48px;object-fit:cover;border-radius:6px}.c{text-align:center}.r{text-align:right;white-space:nowrap}' +
        '.tot{display:flex;justify-content:flex-end;gap:24px;margin:14px 0;font-size:16px;font-weight:800}.box{background:#f5f2ff;border-radius:10px;padding:10px 14px;margin:0 0 10px;line-height:1.45}.box p{margin:3px 0}' +
        '.ft{margin-top:18px;font-size:10.5px;color:#6f6a80;line-height:1.5}.ft a{color:#7c3aed}</style><\/he'+'ad><bo'+'dy>' +
        '<div class="hd"><div class="lg">PIXEL <span>404</span></div><div class="ad">Pixel 404<br>84 boulevard Alexandre Martin<br>45000 Orléans<br>www.pixel404.fr</div></div>' +
        '<h1>Récapitulatif de panier' + (entry.name ? ' – ' + esc(entry.name) : '') + '</h1>' +
        '<p class="meta">Établi le ' + d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) + ' · prix TTC, sous réserve de stock et d’évolution des prix</p>' +
        '<table><thead><tr><th></th><th>Article</th><th class="c">Qté</th><th class="r">Prix unit.</th><th class="r">Total</th></tr></thead><tbody>' + rows + '</tbody></table>' +
        '<div class="tot"><span>Total TTC</span><span>' + money(tot) + '</span></div>' +
        '<div class="box">' + four + '<p>Retrait <b>gratuit</b> en boutique à Orléans · livraison <b>offerte dès 50 €</b> (Chronopost, Colissimo, Mondial Relay).</p>' + (pts ? '<p>Cette commande rapporte <b>' + num(pts) + ' points fidélité</b>.</p>' : '') + '</div>' +
        '<div class="ft">Retrouvez ce panier en ligne : <a href="' + esc(shareURL(entry)) + '">' + esc(shareURL(entry)) + '</a><br>Document informatif, ne vaut pas facture.</div>' +
        '<script>window.onload=function(){setTimeout(function(){window.print()},400)}<\/script><\/bo'+'dy><\/html>';
      w.document.open(); w.document.write(html); w.document.close();
    }

    /* pictogramme dans l'en-tête, à gauche de chaque bouton panier */
    function putHeaderIcon() {
      document.querySelectorAll('[data-cart-toggle]').forEach(function (b) {
        var prev = b.previousElementSibling;
        if (prev && prev.classList.contains('pxl-sv-ico')) return;
        var a = document.createElement('a');
        a.className = 'pxm-ibtn pxl-sv-ico';
        a.href = SAVED_URL;
        a.setAttribute('aria-label', 'Mes paniers enregistrés');
        a.title = 'Mes paniers enregistrés';
        a.innerHTML = ICO_BOOK + '<b></b>';
        b.parentNode.insertBefore(a, b);
      });
      refreshCount();
    }

    /* boutons Enregistrer / Partager / PDF sur la page panier */
    function putCartBar(footer, ctas) {
      if (!footer || !ctas) return;
      if (footer.querySelector('.pxl-sv-bar')) return;
      var bar = document.createElement('div');
      bar.className = 'pxl-sv-bar';
      bar.innerHTML = '<button type="button" class="pxl-sv-btn" data-sv="save">' + ICO_BOOK + 'Enregistrer</button>' +
        '<button type="button" class="pxl-sv-btn" data-sv="share">' + ICO_SHARE + 'Partager</button>' +
        '<button type="button" class="pxl-sv-btn" data-sv="pdf">' + ICO_PDF + 'PDF</button>';
      ctas.parentNode.insertBefore(bar, ctas.nextSibling);
    }
    var CART_CACHE = null, CART_KEY = '';
    function cacheCart(key) {
      if (key === CART_KEY) return;
      CART_KEY = key;
      getCart().then(function (c) { CART_CACHE = { items: itemsFromCart(c) }; });
    }
    function currentEntry(name) {
      return getCart().then(function (c) { return { id: String(Date.now()), name: name || '', date: Date.now(), items: itemsFromCart(c) }; });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-sv]') : null;
      if (!b) return;
      var act = b.getAttribute('data-sv');
      if (act === 'save') {
        e.preventDefault();
        var bar = b.closest('.pxl-sv-bar');
        if (bar.querySelector('.pxl-sv-form')) return;
        var f = document.createElement('form');
        f.className = 'pxl-sv-form';
        f.innerHTML = '<input type="text" name="n" maxlength="40" placeholder="Nom du panier (ex. Config Lucas)" aria-label="Nom du panier"><button type="submit" class="pxl-sv-btn pxl-sv-btn--dark">OK</button>';
        bar.appendChild(f);
        f.querySelector('input').focus();
        f.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var n = f.querySelector('input').value.trim();
          currentEntry(n || ('Panier du ' + new Date().toLocaleDateString('fr-FR'))).then(function (en) {
            if (!en.items.length) { toast('Votre panier est vide.'); return; }
            var list = loadSaved(); list.unshift(en); storeSaved(list);
            f.remove();
            toast('Panier enregistré. <a href="' + SAVED_URL + '">Mes paniers</a>', 5000);
          });
        });
      } else if (act === 'share' || act === 'pdf') {
        e.preventDefault();
        /* fenêtre / partage ouverts dans le geste du clic (sinon bloqués par le navigateur) */
        var cached = CART_CACHE && CART_CACHE.items.length ? { id: String(Date.now()), name: '', date: Date.now(), items: CART_CACHE.items } : null;
        if (cached) { if (act === 'share') doShare(cached); else doPDF(cached); return; }
        var w = act === 'pdf' ? window.open('', '_blank') : null;
        currentEntry('').then(function (en) {
          if (!en.items.length) { if (w) w.close(); toast('Votre panier est vide.'); return; }
          if (act === 'share') doShare(en); else doPDF(en, w);
        });
      }
    });

    /* ---------- page /pages/mes-paniers ---------- */
    function cardHTML(en, shared) {
      var items = en.items.map(function (it) {
        return '<li>' + (it.i ? '<img src="' + esc(it.i) + (it.i.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<img alt="">') + '<a href="' + esc(it.u) + '">' + esc(it.t) + (it.q > 1 ? ' <small>× ' + it.q + '</small>' : '') + '</a><span>' + money(it.p * it.q) + '</span></li>';
      }).join('');
      var tot = totalOf(en.items);
      var d = new Date(en.date || Date.now());
      return '<article class="pxl-svp-card' + (shared ? ' is-shared' : '') + '" data-id="' + esc(en.id) + '">' +
        (shared ? '<p class="pxl-svp-kick">Panier partagé avec vous</p>' : '') +
        '<div class="pxl-svp-head"><h2 class="pxl-svp-name">' + esc(en.name || 'Mon panier') + '</h2>' + (shared ? '' : '<span class="pxl-svp-date">' + d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' }) + '</span>') + '</div>' +
        '<ul class="pxl-svp-items">' + items + '</ul>' +
        '<div class="pxl-svp-tot"><span>Total <small>(' + en.items.reduce(function (s, it) { return s + it.q; }, 0) + ' article' + (en.items.length > 1 ? 's' : '') + ')</small></span><span>' + money(tot) + '</span></div>' +
        '<div class="pxl-svp-acts">' +
          '<button type="button" class="pxl-sv-btn pxl-sv-btn--dark" data-svp="load">Mettre dans mon panier</button>' +
          (shared ? '<button type="button" class="pxl-sv-btn" data-svp="keep">' + ICO_BOOK + 'Enregistrer</button>' : '') +
          '<button type="button" class="pxl-sv-btn" data-svp="share">' + ICO_SHARE + 'Partager</button>' +
          '<button type="button" class="pxl-sv-btn" data-svp="pdf">' + ICO_PDF + 'PDF</button>' +
          (shared ? '' : '<button type="button" class="pxl-sv-btn" data-svp="del">Supprimer</button>') +
        '</div></article>';
    }
    function loadShared() {
      var q = new URLSearchParams(location.search);
      var p = q.get('p'); if (!p) return Promise.resolve(null);
      var parts = p.split(',').map(function (s) { var a = s.split('*'); return { h: a[0], v: parseInt(a[1], 10), q: Math.max(1, Math.min(20, parseInt(a[2], 10) || 1)) }; }).filter(function (x) { return x.h && x.v; }).slice(0, 25);
      return Promise.all(parts.map(function (x) {
        return fetch('/products/' + encodeURIComponent(x.h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
          if (!pr) return null;
          var v = (pr.variants || []).filter(function (vv) { return vv.id === x.v; })[0];
          if (!v) return null;
          return { h: x.h, v: x.v, q: x.q, t: pr.title + (v.title && v.title !== 'Default Title' && v.title !== 'Default' ? ' – ' + v.title : ''), i: (v.featured_image && v.featured_image.src) || pr.featured_image || '', p: v.price, u: '/products/' + x.h + '?variant=' + x.v, ok: v.available };
        }).catch(function () { return null; });
      })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) return null;
        return { id: 'shared', name: q.get('n') || 'Panier partagé', date: Date.now(), items: items };
      });
    }
    function renderPage(root) {
      var saved = loadSaved();
      loadShared().then(function (sh) {
        root._shared = sh;
        var html = '';
        if (sh) html += cardHTML(sh, true);
        html += '<p class="pxl-svp-note">Vos paniers sont gardés sur cet appareil. Pour les retrouver ailleurs, utilisez <b>Partager</b> ou <b>PDF</b>.</p>';
        html += saved.length ? saved.map(function (en) { return cardHTML(en, false); }).join('') :
          '<div class="pxl-svp-empty">Aucun panier enregistré pour l’instant.<br>Depuis votre <a href="/cart">panier</a>, cliquez sur <b>Enregistrer</b> pour le retrouver ici.</div>';
        root.innerHTML = html;
      });
    }
    function initPage() {
      var root = document.getElementById('pxl-saved-root');
      if (!root && location.pathname.replace(/\/$/, '') === SAVED_URL) {
        var host = document.querySelector('.shopify-section[id$="__main-page"]') || document.querySelector('main') || document.body;
        var wrap = document.createElement('div');
        wrap.className = 'pxl-svp-wrap';
        wrap.innerHTML = '<h1 class="pxl-svp-title">Mes paniers enregistrés</h1><p class="pxl-svp-sub">Retrouvez vos configurations, remettez-les dans votre panier en un clic, partagez-les ou téléchargez-les en PDF.</p><div id="pxl-saved-root"></div>';
        host.appendChild(wrap);
        root = document.getElementById('pxl-saved-root');
      }
      if (!root || root._init) return;
      root._init = true;
      renderPage(root);
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-svp]'); if (!b) return;
        var card = b.closest('.pxl-svp-card'); var id = card.getAttribute('data-id');
        var en = id === 'shared' ? root._shared : loadSaved().filter(function (x) { return x.id === id; })[0];
        if (!en) return;
        var act = b.getAttribute('data-svp');
        if (act === 'load') {
          b.disabled = true; b.textContent = 'Ajout…';
          addAll(en.items).then(function () { location.href = '/cart'; }).catch(function (err) { b.disabled = false; b.textContent = 'Mettre dans mon panier'; toast('Un article n’est plus disponible : ' + esc(err.message)); });
        } else if (act === 'keep') {
          var list = loadSaved(); var c = JSON.parse(JSON.stringify(en)); c.id = String(Date.now()); list.unshift(c); storeSaved(list);
          toast('Panier enregistré sur cet appareil.'); history.replaceState(null, '', SAVED_URL); renderPage(root);
        } else if (act === 'share') doShare(en);
        else if (act === 'pdf') doPDF(en);
        else if (act === 'del') {
          storeSaved(loadSaved().filter(function (x) { return x.id !== id; })); renderPage(root);
        }
      });
    }

    /* ---------- application (mini-panier, page panier, en-tête) ---------- */
    function applyAll() {
      putHeaderIcon();
      initPage();

      /* mini-panier */
      var dr = document.querySelector('[class*="ai-minidrawer"]');
      if (dr) {
        var tot = dr.querySelector('.pxm-ctot');
        var cents = tot ? parseCents(tot.textContent) : null;
        var fin = dr.querySelector('.pxm-cfin');
        if (fin && cents) putFid(fin, cents, 'after');
        var rows = dr.querySelectorAll('[data-pid]');
        var show = Array.prototype.some.call(rows, function (r) { return REPRISE_RE.test(r.getAttribute('data-pt') || ''); });
        var fid = fin ? fin.parentNode.querySelector(':scope > .pxl-fid') : null;
        if (fin) putRep(fin.parentNode, (fid || fin).nextElementSibling, show);
      }

      /* page panier */
      var footer = document.querySelector('.cart .cart__footer');
      if (footer) {
        var ship = footer.querySelector('.cart__ship');
        var tt = footer.querySelector('.cart__totals');
        var c2 = tt ? parseCents(tt.textContent) : null;
        if (ship && c2) putFid(ship, c2, 'after');
        putCartBar(footer, footer.querySelector('.cart__ctas'));
        if (tt) cacheCart(tt.textContent.replace(/\s+/g, ''));
        var items = document.querySelector('.cart .cart__items');
        if (items && !items._pxlRepChecked) {
          items._pxlRepChecked = true;
          getCart().then(function (c) {
            var show2 = (c.items || []).some(function (it) { return REPRISE_RE.test((it.product_type || '') + ' ' + (it.product_title || '')); });
            putRep(items, items.querySelector(':scope > .pxl-cart-sug'), show2);
          });
        }
      }
    }

    var busy = false, timer = null;
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(timer);
      timer = setTimeout(function () { busy = true; try { applyAll(); } finally { busy = false; } }, 80);
    }).observe(document.body, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll); else applyAll();
    window.addEventListener('storage', function (e) { if (e.key === KEY) refreshCount(); });
  })();

/* ===== pxl-drawer-tweaks : script 13 ===== */
(function () {
    function run() {
      var r = document.querySelector('[class*="ai-minidrawer"]');
      if (!r) return;
      var em = r.querySelector('.pxm-ctitle em');
      if (em) {
        var m = em.textContent.match(/^\s*\((\d+)\)\s*$/);
        if (m) {
          var n = parseInt(m[1], 10);
          em.textContent = n + (n > 1 ? ' articles sont' : ' article est') + ' dans le panier actuellement';
          em.classList.add('pxl-cnt');
        }
      }
      r.querySelectorAll('.pxl-fin-t').forEach(function (h) {
        var nx = h.nextElementSibling;
        if (!nx || !nx.classList.contains('pxm-cfin')) h.remove();
      });
      var fin = r.querySelector('.pxm-cfin');
      if (fin) {
        var pv = fin.previousElementSibling;
        if (!pv || !pv.classList.contains('pxl-fin-t')) {
          var h = document.createElement('p');
          h.className = 'pxl-fin-t';
          h.textContent = 'Retrait et livraison';
          fin.parentNode.insertBefore(h, fin);
        }
      }
    }
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); }).observe(document.body, { childList: true, subtree: true });
    run();
  })();

/* ===== pxl-drawer-tweaks : script 19 ===== */
(function () {
    function mini() {
      document.querySelectorAll('[class*="ai-minidrawer"] .pxl-a-mini').forEach(function (mi) {
        if (mi.dataset.pxl2) return;
        var st = mi.querySelector('strong'), lg = mi.querySelector('.pxl-a-logo');
        if (!st || !lg) return;
        var amt = st.textContent.replace(/^\s*4\s*[×x]\s*/, '');
        mi.dataset.pxl2 = '1';
        mi.innerHTML = '<span>ou réglez en 4x sans frais <strong>' + amt + '</strong> avec</span>';
        mi.appendChild(lg);
      });
    }
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(mini, 150); }).observe(document.body, { childList: true, subtree: true });
    mini();
  })();

/* ===== pxl-drawer-tweaks : script 23 ===== */
(function () {
    function pay() {
      var tpl = document.getElementById('pxl-pay-icons');
      if (!tpl) return;
      document.querySelectorAll('[class*="ai-minidrawer"] .pxm-ctot').forEach(function (t) {
        if (t.querySelector('.pxl-pay-in')) return;
        var b = t.querySelector('b');
        if (!b) return;
        var w = document.createElement('span');
        w.className = 'pxl-pay-in';
        w.setAttribute('aria-label', 'Moyens de paiement acceptés');
        w.innerHTML = tpl.innerHTML;
        t.insertBefore(w, b);
      });
    }
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(pay, 150); }).observe(document.body, { childList: true, subtree: true });
    pay();
  })();

/* ===== pxl-drawer-tweaks : script 33 ===== */
(function () {
    var TITLE = 'Délais de retrait et de livraison';
    function steps() {
      var r = document.querySelector('[class*="ai-minidrawer"]');
      if (!r) return;
      var h = r.querySelector('.pxl-fin-t');
      if (h && !h.dataset.pxl3) {
        h.dataset.pxl3 = '1';
        h.textContent = TITLE;
        var s = document.createElement('small');
        s.textContent = 'Vous choisirez votre mode de livraison à l’étape suivante.';
        h.appendChild(s);
      }
      var go = r.querySelector('.pxm-cgo');
      if (go) {
        if (go.textContent.trim() !== 'Valider mon panier') go.textContent = 'Valider mon panier';
        var nx = go.parentNode.querySelector(':scope > .pxl-go-note'); go.parentNode.querySelectorAll(':scope > .pxl-go-note').forEach(function (d, i) { if (i) d.remove(); });
        if (!nx) {
          var n = document.createElement('p');
          n.className = 'pxl-go-note';
          n.textContent = 'Livraison et paiement en 1x, 3x, 4x ou 10x à choisir à l’étape suivante';
          go.parentNode.insertBefore(n, go.nextSibling);
        }
      }
    }
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(steps, 160); }).observe(document.body, { childList: true, subtree: true });
    steps();
  })();

/* ===== pxl-drawer-tweaks : script 37 ===== */
(function () {
    var LOGGED = PXL_CFG.logged;
    var RKEY = 'pxl_recent_v1', SKEY = 'pxl_saved_carts_v1';

    /* produits consultés : mémorisés sur cet appareil */
    try {
      var pm = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (pm) {
        var rh = decodeURIComponent(pm[1]), ra = JSON.parse(localStorage.getItem(RKEY) || '[]').filter(function (x) { return x !== rh; });
        ra.unshift(rh); localStorage.setItem(RKEY, JSON.stringify(ra.slice(0, 12)));
      }
    } catch (e) {}

    function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function eur(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function lc(s) { s = String(s || '').trim(); return s.charAt(0).toLowerCase() + s.slice(1); }

    /* ---------- délais : grille compacte 2 × 2 ---------- */
    /* dates en toutes lettres : « Lundi 2 Novembre » (les abréviations de la page panier sont développées) */
    var FULL = {};
    ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche', 'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'].forEach(function (w) { FULL[w] = w; });
    var ABBR = { lun: 'lundi', mar: 'mardi', mer: 'mercredi', jeu: 'jeudi', ven: 'vendredi', sam: 'samedi', dim: 'dimanche', janv: 'janvier', 'févr': 'février', avr: 'avril', juil: 'juillet', sept: 'septembre', oct: 'octobre', nov: 'novembre', 'déc': 'décembre' };
    function shortD(s) {
      s = String(s || '').replace(/^\s*prêt\s+/i, '').replace(/\s+/g, ' ').trim();
      s = s.replace(/[a-zéèêûôàç]+\.?/gi, function (w) { var k = w.replace(/\.$/, '').toLowerCase(); var f = FULL[k] || ABBR[k]; return f ? f.charAt(0).toUpperCase() + f.slice(1) : w; });
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
    function cell(label, date, tag, logo) {
      if (!date) return '';
      var t = String(tag || '').trim(), free = /gratuit|offert/i.test(t);
      return '<div><span>' + label + '</span>' + (logo ? '<img src="' + esc(logo) + '" alt="" loading="lazy">' : '') + '<b>' + esc(shortD(date)) + '</b>' + (t ? '<em' + (free ? '' : ' class="is-p"') + '>' + esc(t.toLowerCase()) + '</em>' : '') + '</div>';
    }
    var LABELS = ['Retrait boutique', 'Express', 'Standard', 'Point relais'];
    function gridHTML(rows, note) {
      return rows.map(function (r, i) { return cell(LABELS[i], r[0], r[1], r[2]); }).join('') + (note ? '<p>' + note + '</p>' : '');
    }
    function putGrid(host, html) {
      var g = host.querySelector(':scope > .pxl-shg');
      if (!g) { g = document.createElement('div'); g.className = 'pxl-shg'; host.appendChild(g); }
      if (g.dataset.h !== html) { g.dataset.h = html; g.innerHTML = html; }
      if (!host.classList.contains('pxl-g')) host.classList.add('pxl-g');
    }
    function drawerGrid() {
      var r = document.querySelector('[class*="ai-minidrawer"]');
      var fin = r && r.querySelector('.pxm-cfin');
      if (!fin) return;
      var ps = fin.querySelectorAll(':scope > p:not(.is-sub)');
      if (!ps.length) return;
      var rows = Array.prototype.slice.call(ps, 0, 4).map(function (p, i) {
        var b = p.querySelector('.pxl-car-date') || p.querySelector('b'), em = p.querySelector('em'), im = p.querySelector('img');
        return [b && b.textContent, i === 0 ? 'gratuit' : (em ? em.textContent : ''), im && im.getAttribute('src')];
      });
      putGrid(fin, gridHTML(rows, ''));
    }
    function cartGrid() {
      var ship = document.querySelector('.cart .cart__ship');
      if (!ship) return;
      var rs = ship.querySelectorAll('.cart__ship-row');
      if (!rs.length) return;
      var rows = Array.prototype.slice.call(rs, 0, 4).map(function (r, i) {
        var v = r.querySelector('.cart__ship-val'), em = r.querySelector('em'), im = r.querySelector('img');
        return [v && v.textContent, i === 0 ? 'gratuit' : (em ? em.textContent : ''), im && im.getAttribute('src')];
      });
      putGrid(ship, gridHTML(rows, 'Choix du mode à l’étape suivante'));
    }
    function cartPP() {
      document.querySelectorAll('.cart .pxa--pp').forEach(function (p) { p.classList.add('pxl-ppc'); });
    }
    document.addEventListener('click', function (e) {
      var h = e.target.closest ? e.target.closest('.cart .pxa--pp.pxl-ppc .pxa__head') : null;
      if (h && window.matchMedia('(max-width: 750px)').matches) {
        var p = h.parentNode; p.classList.toggle('is-open');
      }
    });

    /* ---------- paniers vides ---------- */
    var I = {
      pc: '<path d="M7 3h10v18H7z"/><path d="M10 7h4M10 11h4"/><circle cx="12" cy="16.5" r="1.3"/>',
      cpu: '<rect x="6" y="6" width="12" height="12" rx="2"/><path d="M10 10h4v4h-4zM9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3"/>',
      card: '<rect x="4" y="5" width="11" height="15" rx="2" transform="rotate(-8 9.5 12.5)"/><rect x="9" y="4" width="11" height="15" rx="2"/><circle cx="14.5" cy="11.5" r="2.5"/>',
      pad: '<path d="M7 8h10a4 4 0 0 1 4 4v2a3 3 0 0 1-5.4 1.8L14 14h-4l-1.6 1.8A3 3 0 0 1 3 14v-2a4 4 0 0 1 4-4z"/><path d="M8 11v3M6.5 12.5h3"/><circle cx="16" cy="11.5" r=".8"/><circle cx="17.5" cy="13.5" r=".8"/>',
      fig: '<circle cx="12" cy="6" r="3"/><path d="M8 21v-5l-2-3 3-3h6l3 3-2 3v5"/>',
      fix: '<path d="M14.7 6.3a4 4 0 0 0 5 5L21 13l-8 8-4-4 8-8-1.3-1.3a4 4 0 0 0-5-5z" transform="translate(-2 0)"/><path d="M5 19l3-3"/>',
      pin: '<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
      truck: '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
      back: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>'
    };
    function svg(k) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + I[k] + '</svg>'; }
    var RAYS = [
      ['PC Gamer', '/collections/pc-gamer', 'pc', 'https://cdn.shopify.com/s/files/1/0964/7403/8602/files/Designsanstitre_45_ee314e43-056d-49ca-adf6-387969e8b522.png'],
      ['Composants', '/collections/composants-pc', 'cpu', 'https://cdn.shopify.com/s/files/1/0964/7403/8602/files/fc46ebf1-e4a832_66e9248cc51e409cad56b5f17369662e_mv2.webp'],
      ['Cartes Pokémon', '/collections/cartes-a-jouer-et-a-collectionner-pokemon-tcg', 'card', 'https://cdn.shopify.com/s/files/1/0964/7403/8602/files/360d4532-e4a832_cfc7730a2f1f418388ea774b5da5c813_mv2.jpg'],
      ['Jeux vidéo', '/collections/jeux-video', 'pad', 'https://cdn.shopify.com/s/files/1/0964/7403/8602/files/81YYjENP_EL._AC_SL1500.jpg'],
      ['Figurines', '/collections/figurines', 'fig', 'https://cdn.shopify.com/s/files/1/0964/7403/8602/files/32540064-e4a832_82fa763de9a349299f0565fad3db8ba4_mv2.jpg'],
      ['Réparation', '/pages/reparation', 'fix', 'https://cdn.shopify.com/s/files/1/0964/7403/8602/files/71xE7aU12nL._AC_SL1500.jpg']
    ];
    function savedCount() { try { return (JSON.parse(localStorage.getItem(SKEY) || '[]') || []).length; } catch (e) { return 0; } }
    function empHTML() {
      var n = savedCount();
      return '<div class="pxl-emp">' +
        '<div class="pxl-emp__hero pxl-emp__nf"><div class="pxl-emp__pc" aria-hidden="true"></div><span class="pxl-emp__tag">Panier vide</span><div class="pxl-emp__k">404</div><p class="pxl-emp__h">Votre panier est en 404</p><p class="pxl-emp__p">Rien ici pour l’instant… mais votre prochain setup vous attend.</p><a class="pxl-emp__cta" href="/collections/all?sort_by=created-descending">Découvrir les nouveautés</a></div>' +
        '<p class="pxl-emp__t">Nos rayons</p><div class="pxl-emp__rays">' + RAYS.map(function (r) { return '<a class="pxl-emp__ray" href="' + r[1] + '">' + '<img src="' + r[3] + '?width=200" alt="" loading="lazy" width="72" height="72">' + esc(r[0]) + '</a>'; }).join('') + '</div>' +
        '<div class="pxl-emp__reco" hidden><p class="pxl-emp__t"></p><div class="pxl-emp__car"></div></div>' +
        (n ? '<a class="pxl-emp__sv" href="/pages/mes-paniers"><span>Vous avez ' + n + ' panier' + (n > 1 ? 's enregistrés' : ' enregistré') + '</span><i aria-hidden="true"></i></a>' : '') +
        (LOGGED ? '' : '<p class="pxl-emp__lg"><a href="/account/login">Connectez-vous</a> pour retrouver vos points fidélité.</p>') +
        '<div class="pxl-emp__tr"><div>' + svg('pin') + 'Retrait 1h<br>à Orléans</div><div>' + svg('truck') + 'Livraison offerte<br>dès 50 €</div><div>' + svg('back') + '14 jours pour<br>changer d’avis</div></div>' +
        '</div>';
    }

    /* vus récemment (sinon nos incontournables), chargés une seule fois */
    var RECO = null;
    function loadReco() {
      if (RECO) return RECO;
      var hs = [];
      try { hs = JSON.parse(localStorage.getItem(RKEY) || '[]') || []; } catch (e) {}
      function norm(p, cents) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) return null;
        var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
        if (typeof img !== 'string') img = img.src || '';
        if (img.indexOf('//') === 0) img = 'https:' + img;
        return { vid: v.id, title: p.title, url: '/products/' + p.handle, img: img, price: cents ? v.price : Math.round(parseFloat(v.price) * 100) };
      }
      RECO = Promise.all(hs.slice(0, 8).map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { return p ? norm(p, true) : null; }).catch(function () { return null; });
      })).then(function (list) {
        list = list.filter(Boolean).slice(0, 6);
        if (list.length >= 2) return { t: 'Vus récemment', list: list };
        return Promise.all(['cartes-a-jouer-et-a-collectionner-pokemon-tcg', 'figurines', 'pc-gamer'].map(function (h) {
          return fetch('/collections/' + h + '/products.json?limit=6').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) { return (d.products || []).map(function (p) { return norm(p, false); }).filter(function (x) { return x && x.img; }); }).catch(function () { return []; });
        })).then(function (ls) {
          var out = [];
          for (var k = 0; k < 6 && out.length < 6; k++) ls.forEach(function (l) { if (l[k] && out.length < 6) out.push(l[k]); });
          return { t: 'Nos incontournables', list: out };
        });
      });
      return RECO;
    }
    function fillReco(host) {
      var box = host.querySelector('.pxl-emp__reco');
      if (!box || box._pxl) return;
      box._pxl = true;
      loadReco().then(function (res) {
        if (!res || !res.list.length || !box.isConnected) return;
        box.querySelector('.pxl-emp__t').textContent = res.t;
        box.querySelector('.pxl-emp__car').innerHTML = res.list.map(function (p) {
          var src = p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
          return '<div class="pxl-emp__c"><a class="pxl-emp__ci" href="' + esc(p.url) + '"><img src="' + esc(src) + '" alt="" loading="lazy" width="116" height="116"></a><a class="pxl-emp__cn" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="pxl-emp__cb"><b>' + eur(p.price) + '</b><button type="button" data-pxl-add="' + p.vid + '" aria-label="Ajouter au panier">+</button></div></div>';
        }).join('');
        box.hidden = false;
      });
    }
    function empties() {
      var hosts = [];
      var d = document.querySelector('[class*="ai-minidrawer"] .pxm-cempty');
      if (d) hosts.push(d);
      var c = document.querySelector('.cart .cart__form > .cart__empty');
      if (c) hosts.push(c);
      hosts.forEach(function (h) {
        if (!h.querySelector(':scope > .pxl-emp')) { h.innerHTML = empHTML(); h.classList.add('pxl-emp-host'); }
        fillReco(h);
      });
    }

    function run() { drawerGrid(); cartGrid(); cartPP(); empties(); }
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 170); }).observe(document.body, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

/* ===== pxl-drawer-tweaks : script 41 ===== */
(function () {
    /* la reprise passe sous les articles (copie dans le volet articles, l'original reste masqué dans le récap) */
    function run() {
      var r = document.querySelector('[class*="ai-minidrawer"]');
      if (!r) return;
      var list = r.querySelector('.pxm-clist'), foot = r.querySelector('.pxm-cfoot');
      var c = list && list.querySelector(':scope > .pxl-rep2');
      var o = foot && foot.querySelector(':scope > .pxl-rep');
      if (window.innerWidth < 1025 || !o || !list) { if (c) c.remove(); return; }
      if (!c) {
        c = o.cloneNode(true); c.classList.add('pxl-rep2');
        list.appendChild(c);
      }
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; run(); }, 200); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', later);
    run();
  })();

/* ===== pxl-drawer-tweaks : script 45 ===== */
(function () {
    /* regroupe la partie Alma de l'encadré du mini-panier dans son propre bloc */
    function wrap() {
      document.querySelectorAll('[class*="ai-minidrawer"] .pxl-split:not(.pxl-split--pp)').forEach(function (s) {
        if (s.querySelector(':scope > .pxl-a-alma') || !s.querySelector(':scope > .pxl-a-head')) return;
        var w = document.createElement('div');
        w.className = 'pxl-a-alma';
        Array.prototype.slice.call(s.children).forEach(function (c) {
          if (!c.classList.contains('pxl-a-pp') && !c.classList.contains('pxl-a-mini')) w.appendChild(c);
        });
        s.insertBefore(w, s.firstChild);
      });
      note('[class*="ai-minidrawer"] .pxl-a-alma', 'Simulation · choisissez « Alma - Payez en plusieurs fois » à l’étape paiement');
      note('[class*="ai-minidrawer"] .pxl-a-pp', 'Simulation · choisissez PayPal à l’étape paiement, puis le paiement en plusieurs fois dans la fenêtre PayPal');
    }
    function note(sel, txt) {
      document.querySelectorAll(sel).forEach(function (b) {
        if (b.querySelector(':scope > .pxl-a-note')) return;
        var p = document.createElement('p');
        p.className = 'pxl-a-note';
        p.textContent = txt;
        b.appendChild(p);
      });
    }
    var t = null;
    new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; wrap(); }, 120); }).observe(document.body, { childList: true, subtree: true });
    wrap();
  })();

/* ===== pxl-drawer-tweaks : script 49 ===== */
(function () {
    var PACK_PID = 16114882707786;
    var PROP = 'Article protégé';
    /* [tranche de prix][durée] : +1 an / +2 ans */
    var VID = [[63959920247114, 63959920771402], [63959920804170, 63959920836938], [63959920869706, 63959920902474], [63959920935242, 63959920968010]];
    var PRICE = [[29, 45], [59, 89], [109, 159], [159, 229]];
    var TECH = /(pc gamer|pc bureautique|pack pc|pc portable|carte[s]? graphique|processeur|carte[s]? m[eè]re|m[eé]moire|\bram\b|disque|ssd|alimentation|bo[iî]tier|moniteur|[eé]cran|clavier|souris|casque|console|manette|ventirad|watercooling|fauteuil|chaise gaming|bureau gaming)/i;
    var USED = /(reconditionn|occasion)/i;
    var PC = /(^|\s)(pc gamer|pack pc|pc bureautique)/i;

    function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function tier(cents) { return cents < 30000 ? 0 : cents < 80000 ? 1 : cents <= 150000 ? 2 : 3; }
    function txt(it) { return (it.product_type || '') + ' ' + (it.product_title || '') + ' ' + (it.variant_title || ''); }

    function build(cart) {
      var items = (cart.items || []).filter(function (it) { return it.product_id !== PACK_PID && !it.gift_card; });
      if (!items.length) return null;
      var packs = (cart.items || []).filter(function (it) { return it.product_id === PACK_PID; });
      /* garantie adaptée à chaque objet : on nomme ce que le client achète */
      var NOUN = { 'pc gamer': ['PC Gamer', 'PC Gamer'], 'pack pc': ['pack PC', 'packs PC'], 'pc bureautique': ['PC', 'PC'], 'pc portable': ['PC portable', 'PC portables'], 'pc portable gaming': ['PC portable', 'PC portables'], 'pc portable gaming reconditionné': ['PC portable', 'PC portables'],
        'cartes graphiques': ['carte graphique', 'cartes graphiques'], 'cartes mères': ['carte mère', 'cartes mères'], 'processeurs': ['processeur', 'processeurs'], 'ram': ['barrette de RAM', 'barrettes de RAM'], 'mémoire ram': ['barrette de RAM', 'barrettes de RAM'], 'disques durs': ['disque', 'disques'], 'alimentation pc': ['alimentation', 'alimentations'], 'boîtiers pc': ['boîtier', 'boîtiers'], 'ventirad': ['ventirad', 'ventirads'], 'ventirads': ['ventirad', 'ventirads'], 'dissipateur': ['ventirad', 'ventirads'], 'watercooling': ['watercooling', 'watercoolings'], 'watercooling aio': ['watercooling', 'watercoolings'], 'ventilateur': ['ventilateur', 'ventilateurs'], 'ventilateurs boîtier': ['ventilateur', 'ventilateurs'],
        'écran pc': ['écran', 'écrans'], 'écrans pc': ['écran', 'écrans'], 'moniteur gaming': ['écran', 'écrans'], 'clavier gaming': ['clavier', 'claviers'], 'clavier bureautique': ['clavier', 'claviers'], 'souris': ['souris', 'souris'], 'casque gaming': ['casque', 'casques'], 'casques audio': ['casque', 'casques'], 'écouteurs': ['écouteurs', 'écouteurs'], 'microphone': ['micro', 'micros'], 'microphones': ['micro', 'micros'], 'webcams': ['webcam', 'webcams'], 'enceintes et haut-parleurs': ['enceinte', 'enceintes'], 'stream deck': ['Stream Deck', 'Stream Deck'], 'manettes': ['manette', 'manettes'], 'consoles': ['console', 'consoles'], 'consoles de jeu vidéo': ['console', 'consoles'], 'fauteuils de jeux': ['fauteuil', 'fauteuils'], 'bureau gamer': ['bureau', 'bureaux'], 'tapis de souris': ['tapis de souris', 'tapis de souris'],
        'jeux vidéo': ['jeu', 'jeux'], 'figurines': ['figurine', 'figurines'], 'peluches': ['peluche', 'peluches'], 'porte-clés': ['porte-clés', 'porte-clés'], 'cartes pokémon': ['carte Pokémon', 'cartes Pokémon'], 'jeux de société': ['jeu de société', 'jeux de société'], 'uno': ['jeu Uno', 'jeux Uno'], 'dobble': ['jeu Dobble', 'jeux Dobble'], 'jeu de cartes': ['jeu de cartes', 'jeux de cartes'], 'puzzles': ['puzzle', 'puzzles'], 'tasses': ['tasse', 'tasses'], 'toile': ['toile', 'toiles'], 'vêtements': ['vêtement', 'vêtements'], 'distributeur de savon': ['distributeur de savon', 'distributeurs de savon'], 'sac à dos': ['sac à dos', 'sacs à dos'], 'porte monnaie': ['porte-monnaie', 'porte-monnaie'], 'jouets': ['jouet', 'jouets'], 'jeux de construction': ['jeu de construction', 'jeux de construction'] };
      var POP = /^(figurines|peluches|porte-clés|cartes pokémon|pokémon|jeux de société|uno|dobble|jeu de cartes|puzzles|tasses|toile|vêtements|couverts|distributeur de savon|merchandising k-pop|papeterie|porte monnaie|jouets|jeux de construction|miroir|coques pour téléphones portables|sac à dos|tapis de souris)$/;
      var SKIP = /^(jeu vidéo dématérialisé|service)$/;
      function typ(it) { return (it.product_type || '').trim().toLowerCase().replace(/\\u00e9/g, 'é'); }
      function kind(it) {
        var t = typ(it);
        if (SKIP.test(t)) return '';
        if (USED.test(txt(it))) return 'used';
        if (/^jeux vid/.test(t)) return 'jv';
        if (POP.test(t)) return 'pop';
        return 'tech';
      }
      var grp = { tech: [], used: [], jv: [], pop: [] };
      items.forEach(function (it) {
        var k = kind(it); if (!k) return;
        var n = NOUN[typ(it)] || ['article', 'articles'];
        var g = grp[k].filter(function (x) { return x.n[0] === n[0]; })[0];
        if (g) g.q += it.quantity; else grp[k].push({ n: n, q: it.quantity });
      });
      function sur(list) {
        var w = list.map(function (x) { return x.q > 1 ? 'vos ' + x.n[1] : 'votre ' + x.n[0]; });
        return w.length > 1 ? w.slice(0, -1).join(', ') + ' et ' + w[w.length - 1] : w[0];
      }
      function line(b, list, s) { return '<li><i>✓</i><span><b>' + b + '</b> sur ' + sur(list) + '<small>' + s + '</small></span></li>'; }
      var hasPc = items.some(function (it) { return PC.test(it.product_type || '') || /\bpc gamer\b/i.test(it.product_title || ''); });
      var li = [];
      if (grp.tech.length) li.push(line('Garantie 2 ans incluse', grp.tech, 'Pièces et main-d’œuvre, assurée par Pixel 404 à Orléans'));
      if (hasPc) li.push('<li><i>✓</i><span><b>Entretien illimité pendant 2 ans</b> sur votre PC<small>Dépoussiérage et contrôle en boutique, autant de fois que vous le souhaitez</small></span></li>');
      if (grp.used.length) li.push(line('Garantie 1 an incluse', grp.used, 'Reconditionné ou d’occasion, testé et contrôlé dans notre atelier'));
      if (grp.jv.length) li.push(line('Garantie 2 ans incluse', grp.jv, 'Échangé si le disque ou la cartouche présente un défaut'));
      if (grp.pop.length) li.push(line('Garantie 2 ans incluse', grp.pop, 'Échange ou remboursement si un défaut apparaît'));
      var gar = li.length ? '<p class="pxl-gar__t">Inclus avec votre commande</p><ul>' + li.join('') + '</ul>' : '';

      var elig = items.filter(function (it) { return !USED.test(txt(it)) && TECH.test(txt(it)) && it.price >= 5000; })
        .sort(function (a, b) { return b.price - a.price; });
      var ser = '';
      if (elig.length) {
        ser = '<div class="pxl-ser__h"><b>Pack Sérénité</b><a href="/pages/pack-serenite" target="_blank" rel="noopener">Conditions</a></div>' +
          '<p class="pxl-ser__p">Prolongez la garantie au-delà des 2 ans inclus' + (hasPc ? ', entretien compris' : '') + '.</p>' +
          elig.map(function (it) {
            var t = tier(it.price), name = it.product_title;
            var cur = packs.filter(function (p) { return p.properties && p.properties[PROP] === name; })[0];
            return '<div class="pxl-ser__it"><span class="pxl-ser__n">Pour : ' + esc(name) + '</span>' + [0, 1].map(function (d) {
              var vid = VID[t][d], on = cur && cur.variant_id === vid;
              var price = PRICE[t][d] + ' €' + (it.quantity > 1 ? ' × ' + it.quantity : '');
              return '<button type="button" class="pxl-ser__r' + (on ? ' is-on' : '') + '" data-ser="' + vid + '" data-for="' + esc(name) + '" data-q="' + it.quantity + '" data-cur="' + (cur ? cur.key : '') + '">' +
                '<img src="https://cdn.shopify.com/s/files/1/0964/7403/8602/files/pack-serenite.png?width=120" alt="" width="56" height="56" loading="lazy">' +
                '<span class="pxl-ser__t"><b>Pack Sérénité ' + (d ? '+2 ans<em>Conseillé</em>' : '+1 an') + '</b><small>' + (d ? '4 ans de garantie au total' : '3 ans de garantie au total') + '</small></span>' +
                '<span class="pxl-ser__pr">' + price + '</span><i class="pxl-ser__plus" aria-hidden="true">' + (on ? '✓' : '+') + '</i></button>';
            }).join('') + '</div>';
          }).join('');
      }
      return { gar: gar, ser: ser };
    }

    function place(parent, after, cls, html) {
      var el = parent.querySelector(':scope > .' + cls);
      if (!html) { if (el) el.remove(); return null; }
      if (!el) { el = document.createElement('div'); el.className = cls; }
      if (el.dataset.h !== html) { el.dataset.h = html; el.innerHTML = html; }
      var nx = after.nextElementSibling; while (nx && nx !== el && /\b(pxw-h\d|pxl-mtg-card|pxl-mtg-frame)\b/.test(nx.className)) nx = nx.nextElementSibling; if (nx !== el) parent.insertBefore(el, after.nextSibling);
      return el;
    }
    function render(data) {
      var d = document.querySelector('[class*="ai-minidrawer"] .pxm-clist');
      var c = document.querySelector('.cart .cart__form > .cart__items');
      [d, c].forEach(function (host) {
        if (!host) return;
        var rows = host.querySelectorAll(d === host ? ':scope > .pxm-citem' : ':scope > .cart__item');
        var last = rows[rows.length - 1];
        if (!last || !data) { place(host, host, 'pxl-gar', ''); place(host, host, 'pxl-ser', ''); return; }
        var nx = last.nextElementSibling, anchor = nx && nx.hasAttribute('data-pxag-suggestion') ? nx : last;
        var g = place(host, anchor, 'pxl-gar', data.gar);
        place(host, g || last, 'pxl-ser', data.ser);
      });
    }

    var DATA = null, SIG = '', busy = false;
    function sig() {
      var s = '';
      document.querySelectorAll('[class*="ai-minidrawer"] .pxm-citem').forEach(function (r) { var q = r.querySelector('[data-q]'); s += r.getAttribute('data-pid') + ':' + (q ? q.textContent : '') + ','; });
      document.querySelectorAll('.cart .cart__item').forEach(function (r) { s += r.textContent.length + ','; });
      return s;
    }
    /* le pack suit son article : retiré si l'article n'est plus au panier, même quantité sinon */
    var fixes = 0;
    function sync(cart) {
      if (fixes > 4) return false;
      var q = {};
      (cart.items || []).forEach(function (it) { if (it.product_id !== PACK_PID) q[it.product_title] = (q[it.product_title] || 0) + it.quantity; });
      var bad = (cart.items || []).filter(function (p) { return p.product_id === PACK_PID && p.quantity !== (q[p.properties && p.properties[PROP]] || 0); })[0];
      if (!bad) return false;
      fixes++;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: bad.key, quantity: q[bad.properties && bad.properties[PROP]] || 0 }) }).then(function () {
        var mc = document.querySelector('mini-cart-abjzzqlppuenpu2z3naigenblockb2128c6qgkpd4');
        if (document.querySelector('.cart .cart__items')) location.reload();
        else { if (mc && mc.refreshCart) mc.refreshCart(true); busy = false; setTimeout(function () { refresh(true); }, 600); }
      }).catch(function () { busy = false; });
      return true;
    }
    function refresh(force) {
      var s = sig();
      if (!force && s === SIG && DATA !== null) { render(DATA); return; }
      if (busy) return;
      SIG = s; busy = true;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { if (sync(cart)) return; DATA = build(cart); render(DATA); })
        .catch(function () {}).then(function () { busy = false; });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ser]') : null;
      if (!b) return;
      e.preventDefault();
      var vid = Number(b.getAttribute('data-ser')), name = b.getAttribute('data-for'), q = Number(b.getAttribute('data-q')) || 1, cur = b.getAttribute('data-cur');
      var on = b.classList.contains('is-on');
      b.closest('.pxl-ser').querySelectorAll('[data-ser]').forEach(function (x) { x.disabled = true; });
      var step = cur ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: cur, quantity: 0 }) }) : Promise.resolve();
      step.then(function () {
        if (on) return;
        var props = {}; props[PROP] = name;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: q, properties: props }] }) });
      }).then(function () {
        var mc = b.closest('mini-cart-abjzzqlppuenpu2z3naigenblockb2128c6qgkpd4, [class*="mini-cart"]');
        if (mc && mc.refreshCart) { mc.refreshCart(true); setTimeout(function () { refresh(true); }, 600); }
        else location.reload();
      }).catch(function () { location.reload(); });
    });

    var t = null;
    new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; refresh(false); }, 200); }).observe(document.body, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(true); }); else refresh(true);
  })();

/* ===== pxl-drawer-tweaks : script 53 ===== */
(function () {
    var SEL = ['.pxl-pay', '.pxm-cgo', '.pxm-cpromo', '.pxl-go-note'];
    function dock() {
      var cart = document.querySelector('[class*="ai-minidrawer"] .pxm-cart');
      if (!cart) return;
      var foot = cart.querySelector(':scope > .pxm-cfoot');
      var d = cart.querySelector(':scope > .pxl-dock');
      if (window.innerWidth < 1025 || !foot) {
        if (d) { if (foot) [].slice.call(d.children).forEach(function (k) { if (!k.classList.contains('pxl-dtot')) foot.appendChild(k); }); d.remove(); }
        return;
      }
      if (!d) { d = document.createElement('div'); d.className = 'pxl-dock'; cart.appendChild(d); }
      SEL.forEach(function (s) {
        var el = foot.querySelector(':scope > ' + s);
        if (!el) return;
        var old = d.querySelector(':scope > ' + s);
        if (old) old.remove();
        d.appendChild(el);
      });
      /* prix juste à côté du bouton */
      var tb = foot.querySelector('.pxm-ctot b');
      var dt = d.querySelector(':scope > .pxl-dtot');
      if (!dt) { dt = document.createElement('div'); dt.className = 'pxl-dtot'; d.insertBefore(dt, d.firstChild); }
      var v = tb ? tb.textContent.trim() : '';
      if (dt.dataset.v !== v) { dt.dataset.v = v; dt.innerHTML = '<b></b>'; dt.lastChild.textContent = v; }
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; dock(); }, 120); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', later);
    dock();
  })();

/* ===== pxl-drawer-tweaks : script 57 ===== */
(function () {
    function move() {
      var r = document.querySelector('[class*="ai-minidrawer"]');
      if (!r) return;
      var sg = r.querySelector('[data-pxag-suggestion]');
      var list = r.querySelector('.pxm-clist');
      if (!sg || !list) return;
      var items = list.querySelectorAll(':scope > .pxm-citem');
      var last = items[items.length - 1];
      for (var i = 0; i < items.length; i++) { var cn = items[i].querySelector('.pxm-cn'); if (cn && cn.textContent.indexOf('PC Gamer') > -1) { last = items[i]; sg.classList.add('pxl-gift-pc'); break; } }
      if (last && last.nextElementSibling !== sg) list.insertBefore(sg, last.nextSibling);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; move(); }, 120); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    move();
  })();

/* ===== pxl-drawer-tweaks : script 61 ===== */
(function () {
    var END = PXL_CFG.promo_end;
    var NAME = PXL_CFG.promo_name;
    var ALMA_MAX = (PXL_CFG.alma_max * 100);
    var cmp = {}, cart = null, busy = false, last = '';

    function eur(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
    function live() { return END > Date.now(); }
    function promoType(it) { return /^pc gamer$/i.test((it.product_type || '').trim()); }
    function hms(ms) { var s = Math.max(0, Math.floor(ms / 1000)); var h = Math.floor(s / 3600); return (h > 99 ? Math.floor(h / 24) + 'j ' + String(h % 24).padStart(2, '0') : String(h).padStart(2, '0')) + ':' + String(Math.floor(s % 3600 / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); }

    function loadCmp(items) {
      var need = items.filter(function (it) { return !(it.handle in cmp); }).map(function (it) { return it.handle; });
      need = need.filter(function (h, i) { return need.indexOf(h) === i; });
      return Promise.all(need.map(function (h) {
        cmp[h] = {};
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          (p && p.variants || []).forEach(function (v) { cmp[h][v.id] = v.compare_at_price || 0; });
        }).catch(function () {});
      }));
    }

    function build(c, root) {
      var items = c.items || [];
      if (!items.length) return '';
      var sub = 0, rem = 0, remP = 0, gift = [];
      items.forEach(function (it) {
        var ca = (cmp[it.handle] || {})[it.variant_id] || 0;
        var unit = Math.max(ca, it.original_price);
        sub += unit * it.quantity;
        if (ca > it.original_price) { if (live() && promoType(it)) remP += (ca - it.original_price) * it.quantity; else rem += (ca - it.original_price) * it.quantity; }
        if (it.final_line_price === 0 && it.original_price === 0) gift.push(it);
      });
      var code = c.total_discount || 0;
      var tot = c.total_price;
      var n = c.item_count - gift.reduce(function (s, it) { return s + it.quantity; }, 0);
      var fid = root.querySelector('.pxl-fid b');
      var pd = fid ? parseInt(fid.textContent.replace(/\D/g, ''), 10) : 0;
      var pts = pd ? pd.toLocaleString('fr-FR') : '';
      var h = '';
      if (remP) h += '<div class="pxl-rec__bar"><svg class="pxl-hg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2h12M6 22h12M17 2v4.2a3 3 0 0 1-.9 2.1L12 12l-4.1-3.7A3 3 0 0 1 7 6.2V2M7 22v-4.2a3 3 0 0 1 .9-2.1L12 12l4.1 3.7a3 3 0 0 1 .9 2.1V22"/></svg><span>Plus que <b class="pxl-rec__tm" data-pxl-tm></b> pour profiter du prix ' + esc(NAME) + '</span></div>';
      h += '<div class="pxl-rec__b"><p class="pxl-rec__t">Récapitulatif</p>';
      h += '<div class="pxl-rec__l"><span>Sous-total · ' + n + ' article' + (n > 1 ? 's' : '') + '</span><span>' + eur(sub) + '</span></div>';
      if (remP) h += '<div class="pxl-rec__l pxl-rec__l--red"><span>Remises ' + esc(NAME) + '</span><span>−' + eur(remP) + '</span></div>';
      if (rem) h += '<div class="pxl-rec__l pxl-rec__l--red"><span>' + (remP ? 'Autres remises' : 'Remises') + '</span><span>−' + eur(rem) + '</span></div>';
      if (code) h += '<div class="pxl-rec__l pxl-rec__l--red"><span>Code promo</span><span>−' + eur(code) + '</span></div>';
      h += '<div class="pxl-rec__l"><span>Livraison</span>' + (tot >= 5000 ? '<b class="pxl-ok">Offerte</b>' : '<span>dès 4,99 €</span>') + '</div>';
      gift.forEach(function (it) { h += '<div class="pxl-rec__l"><span>Jeu ' + esc((it.product_title || '').split(' — ')[0]) + '</span><b class="pxl-ok">0,00 €</b></div>'; });
      if (pts) h += '<div class="pxl-rec__l"><span>Points de fidélité</span><b class="pxl-pts">+' + esc(pts) + ' pts</b></div>';
      h += '<div class="pxl-rec__tot"><span>Total TTC</span><b>' + eur(tot) + '</b></div>';
      if (rem + remP + code > 0) h += '<div class="pxl-rec__save">Vous économisez ' + eur(rem + remP + code).replace(',00', '') + ' sur ce panier</div>';
      return h + '</div>';
    }

    function paint() {
      var root = document.querySelector('[class*="ai-minidrawer"]');
      if (!root || !cart) return;
      var foot = root.querySelector('.pxm-cfoot');
      var anchor = foot && (foot.querySelector(':scope > .pxl-fin-t') || foot.querySelector(':scope > .pxm-cfin'));
      if (foot && anchor) {
        var rec = foot.querySelector(':scope > .pxl-rec');
        var html = build(cart, root);
        if (!html) { if (rec) rec.remove(); }
        else {
          if (!rec) { rec = document.createElement('div'); rec.className = 'pxl-rec'; }
          if (rec.dataset.h !== html) { rec.dataset.h = html; rec.innerHTML = html; }
          if (anchor.previousElementSibling !== rec) foot.insertBefore(rec, anchor);
        }
      }
      root.querySelectorAll('.pxm-clist > .pxm-citem').forEach(function (row) {
        var link = row.querySelector('a.pxm-cn, a.pxm-cth');
        var href = link ? link.getAttribute('href') || '' : '';
        var vm = href.match(/variant=(\d+)/);
        var it = (cart.items || []).filter(function (x) { return vm ? String(x.variant_id) === vm[1] : href.indexOf('/products/' + x.handle) > -1; })[0];
        var ca = it ? (cmp[it.handle] || {})[it.variant_id] || 0 : 0;
        var on = live() && it && promoType(it) && ca > it.original_price;
        var chip = row.querySelector('.pxl-chip');
        if (!on) { if (chip) chip.remove(); return; }
        if (!chip) {
          var at = row.querySelector('.pxm-cvar') || row.querySelector('.pxm-cn');
          if (!at) return;
          chip = document.createElement('div'); chip.className = 'pxl-chip';
          chip.innerHTML = '<b>Prix ' + esc(NAME) + '</b>';
          at.insertAdjacentElement('afterend', chip);
        }
      });
      var dt = root.querySelector('.pxl-dtot');
      if (dt) {
        var x4 = dt.querySelector('.pxl-x4');
        var t = cart.total_price;
        var txt = (t >= 5000 && t <= ALMA_MAX) ? 'ou <b>' + eur(Math.ceil(t / 4)) + '</b> en 4x sans frais avec <i>Alma</i>' : '';
        if (!txt) { if (x4) x4.remove(); }
        else {
          if (!x4) { x4 = document.createElement('div'); x4.className = 'pxl-x4'; }
          if (x4.dataset.h !== txt) { x4.dataset.h = txt; x4.innerHTML = txt; }
          if (dt.lastElementChild !== x4) dt.appendChild(x4);
        }
      }
      var ul = root.querySelector('.pxm-clist > .pxl-gar ul');
      var pc = (cart.items || []).some(function (x) { return /pc gamer|pc bureautique|pack pc/i.test(x.product_type || '') || /\bpc gamer\b/i.test(x.product_title || ''); });
      var mli = ul && ul.querySelector(':scope > .pxl-gar-atelier');
      if (ul && pc && !mli) { mli = document.createElement('li'); mli.className = 'pxl-gar-atelier'; mli.innerHTML = '<i>✓</i><span><b>Monté, câblé et testé à la main</b> dans notre atelier d’Orléans<small>Chaque PC est stress-testé avant de partir</small></span>'; ul.insertBefore(mli, ul.firstChild); }
      if (mli && !pc) mli.remove();
      tick();
    }

    function tick() {
      var left = END - Date.now(), v = hms(left);
      document.querySelectorAll('[data-pxl-tm]').forEach(function (e) { if (e.textContent !== v) e.textContent = v; });
      if (END && left <= 0) { END = 0; document.querySelectorAll('.pxl-chip, .pxl-rec__bar').forEach(function (e) { e.remove(); }); }
    }

    function refresh() {
      if (busy) return;
      var root = document.querySelector('[class*="ai-minidrawer"] .pxm-cart');
      if (!root) return;
      busy = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var sig = c.token + '|' + c.total_price + '|' + c.item_count + '|' + c.total_discount;
        cart = c;
        return loadCmp(c.items || []).then(function () { last = sig; });
      }).catch(function () {}).then(function () { busy = false; paint(); });
    }

    var t = null;
    function later() {
      if (t) return;
      t = setTimeout(function () {
        t = null;
        var tb = document.querySelector('[class*="ai-minidrawer"] .pxm-ctot b');
        var sig = (tb ? tb.textContent : '') + '|' + document.querySelectorAll('[class*="ai-minidrawer"] .pxm-citem').length;
        if (sig !== later.sig) { later.sig = sig; refresh(); } else { paint(); }
      }, 150);
    }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (!(n.closest && (n.closest('[data-pxl-tm]') || n.closest('.pxl-rec') || n.closest('.pxl-chip') || n.closest('.pxl-x4') || n.closest('.pxl-gar-atelier')))) { later(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    setInterval(tick, 1000);
    later();
  })();

/* ===== pxl-drawer-tweaks : script 65 ===== */
(function () {
    function put() {
      var p = document.querySelector('[class*="ai-minidrawer"] .pxm-cart > .pxl-dock .pxm-cpromo');
      if (!p || p.querySelector(':scope > .pxl-promo-t')) return;
      var msg = p.querySelector('.pxm-cmsg');
      if (msg && msg.textContent.trim()) p.classList.add('is-open');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pxl-promo-t'; b.textContent = 'Un code promo ?';
      b.addEventListener('click', function () { p.classList.add('is-open'); var i = p.querySelector('input'); if (i) i.focus(); });
      p.insertBefore(b, p.firstChild);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 150); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 69 ===== */
(function () {
    var tpl = document.getElementById('pxl-greviews-tpl');
    function put() {
      var head = document.querySelector('[class*="ai-minidrawer"] .pxm-cart > .pxm-chead');
      if (!head || !tpl) return;
      var x = head.querySelector(':scope > .pxm-cx');
      var el = head.querySelector(':scope > .pxl-grev');
      if (!el) el = tpl.content.firstElementChild.cloneNode(true);
      if (x ? el.nextElementSibling !== x : el.parentNode !== head) head.insertBefore(el, x || null);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 160); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 73 ===== */
(function () {
    var src = document.getElementById('pxl-exp-src');
    var exp = src ? src.querySelector('.pxl-exp') : null;
    function put() {
      var dock = document.querySelector('[class*="ai-minidrawer"] .pxm-cart > .pxl-dock');
      if (!dock) return;
      if (exp && exp.parentNode !== dock) dock.appendChild(exp);
      var x4 = dock.querySelector('.pxl-dtot .pxl-x4');
      if (x4 && x4.dataset.h && x4.dataset.h33 !== x4.dataset.h) {
        var m = /<b>(.*?)<\/b>/.exec(x4.dataset.h);
        if (m) {
          x4.dataset.h33 = x4.dataset.h;
          x4.innerHTML = 'ou <b>' + m[1] + '</b> en 4x avec <i>alma</i>';
          x4.setAttribute('role', 'link');
          x4.setAttribute('tabindex', '0');
          x4.setAttribute('title', 'Choisissez Alma à l’étape paiement');
        }
      }
    }
    function go(e) {
      var x4 = e.target.closest && e.target.closest('[class*="ai-minidrawer"] .pxl-dtot .pxl-x4');
      if (!x4) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      window.location.href = '/checkout';
    }
    document.addEventListener('click', go);
    document.addEventListener('keydown', go);
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 170); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 77 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    function put() {
      var f = document.querySelector(C + ' > .pxm-cfoot');
      var g = document.querySelector(C + ' > .pxm-clist > .pxl-gar');
      var r = f ? f.querySelector(':scope > .pxl-gar-r') : null;
      if (!f || !g) { if (r) r.remove(); return; }
      if (!r) { r = document.createElement('div'); r.className = 'pxl-gar pxl-gar-r'; }
      if (r.innerHTML !== g.innerHTML) r.innerHTML = g.innerHTML;
      if (f.lastElementChild !== r) f.appendChild(r);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 180); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 81 ===== */
(function () {
    var busy = false;
    function fit() {
      if (busy) return;
      var c = document.querySelector('[class*="ai-minidrawer"] .pxm-cart');
      var f = c ? c.querySelector(':scope > .pxm-cfoot') : null;
      if (!f) return;
      busy = true;
      var h = c.querySelector(':scope > .pxm-chead'), d = c.querySelector(':scope > .pxl-dock');
      var ht = h ? h.offsetHeight : 0, dh = d ? d.offsetHeight : 0;
      if (c.style.getPropertyValue('--pxl-ht') !== ht + 'px') c.style.setProperty('--pxl-ht', ht + 'px');
      var z = '';
      if (window.innerWidth >= 1025 && c.clientHeight > 0) {
        var prev = f.style.zoom;
        f.style.zoom = '';
        var nat = f.scrollHeight, av = c.clientHeight - ht - dh - 6;
        if (nat > av && av > 0) z = String(Math.max(0.72, Math.floor(av / nat * 1000) / 1000));
        f.style.zoom = prev;
      }
      if (f.style.zoom !== z) f.style.zoom = z;
      var bg = '';
      if (window.innerWidth >= 1025) {
        var L = Math.round(f.getBoundingClientRect().left - c.getBoundingClientRect().left);
        if (L > 0) bg = 'linear-gradient(90deg, transparent ' + L + 'px, #16151c ' + L + 'px)';
      }
      if (c.dataset.pxlBg !== bg) { c.dataset.pxlBg = bg; c.style.backgroundImage = bg; }
      setTimeout(function () { busy = false; }, 0);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; fit(); }, 150); }
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { var n = m[i].target; if (!(n.closest && n.closest('[data-pxl-tm]'))) { later(); return; } }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', later);
    document.addEventListener('click', function () { setTimeout(fit, 450); });
    fit();
  })();

/* ===== pxl-drawer-tweaks : script 93 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    function put() {
      var f = document.querySelector(C + ' > .pxm-cfoot');
      var s = document.querySelector(C + ' > .pxm-clist > .pxl-ser');
      var r = f ? f.querySelector(':scope > .pxl-ser-r') : null;
      if (!f || !s) { if (r) r.remove(); return; }
      if (!r) {
        r = document.createElement('div'); r.className = 'pxl-ser pxl-ser-r';
        r.innerHTML = '<button type="button" class="pxl-ser-tg" aria-expanded="false"><span>Ajouter un Pack Sérénité</span><i aria-hidden="true"></i></button><div class="pxl-ser-bd"></div>';
      }
      var bd = r.querySelector('.pxl-ser-bd'), h = s.innerHTML;
      if (r.dataset.h !== h) { r.dataset.h = h; bd.innerHTML = h; var on = !!bd.querySelector('.is-on'); r.querySelector('.pxl-ser-tg span').textContent = on ? 'Pack Sérénité ajouté' : 'Ajouter un Pack Sérénité'; r.classList.toggle('has-on', on); }
      if (r.parentNode !== f) f.appendChild(r);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pxl-ser-tg') : null;
      if (!b) return;
      var r = b.parentNode, o = r.classList.toggle('is-open');
      b.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 180); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 97 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    function orig() { return document.querySelector(C + ' .pxm-cpromo'); }
    function put() {
      var f = document.querySelector(C + ' > .pxm-cfoot');
      var rec = f ? f.querySelector(':scope > .pxl-rec') : null;
      var o = orig();
      var m = rec ? rec.querySelector(':scope > .pxl-promo-r') : null;
      if (!rec || !o) { if (m) m.remove(); return; }
      if (!m) {
        m = document.createElement('div'); m.className = 'pxl-promo-r';
        m.innerHTML = '<div class="pxl-promo-f"><input type="text" placeholder="Code promo" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="40" aria-label="Code promo"><button type="button">Appliquer</button></div><p class="pxl-promo-m" aria-live="polite"></p>';
        rec.appendChild(m);
      }
      var om = o.querySelector('[data-promo-msg]'), mm = m.querySelector('.pxl-promo-m'), tx = om ? om.textContent.trim() : '';
      if (mm.textContent !== tx) mm.textContent = tx;
    }
    function apply(m) {
      var o = orig(); if (!o) return;
      var i = m.querySelector('input'), v = i.value.trim();
      if (!v) { i.focus(); return; }
      var oi = o.querySelector('[data-promo-input]'), ob = o.querySelector('[data-promo-submit]');
      if (!oi || !ob) return;
      oi.value = v; oi.dispatchEvent(new Event('input', { bubbles: true }));
      ob.click(); i.value = '';
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pxl-promo-r button') : null;
      if (b) apply(b.closest('.pxl-promo-r'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.closest) return;
      var m = e.target.closest('.pxl-promo-r');
      if (m) { e.preventDefault(); apply(m); }
    });
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 150); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 103 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    var J = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
    function le(d) { d = d.trim(); var l = d.toLowerCase(); return J.some(function (j) { return l.indexOf(j) === 0; }) ? 'le ' + l : l; }
    function put() {
      var cnt = document.querySelector(C + ' > .pxm-chead .pxl-cnt');
      var fin = document.querySelector(C + ' .pxm-cfin');
      var box = document.querySelector(C + ' > .pxm-chead .pxl-hdl');
      if (!cnt || !fin) { if (box) box.remove(); return; }
      var lines = [];
      var once = fin.querySelector('.pxm-copt[data-mode="once"] .pxm-cod');
      if (once) { var d = once.textContent.trim(); if (d.indexOf('Tout ') === 0) d = d.slice(5); if (d) lines.push('Retrait magasin <b>gratuit</b> disponible ' + le(d)); }
      var row = fin.querySelector('.pxl-car-row');
      if (row) {
        var n = row.querySelector('.pxl-car-n'), dt = row.querySelector('.pxl-car-date'), free = row.querySelector('.pxl-free');
        var type = n ? n.textContent.trim().replace('Livraison ', '').toLowerCase() : '';
        if (dt) lines.push('Livraison ' + (free ? '<b>gratuite</b> ' : '') + type + ' disponible ' + le(dt.textContent));
      }
      var html = lines.join('<br>');
      if (!html) { if (box) box.remove(); return; }
      if (!box) { box = document.createElement('span'); box.className = 'pxl-hdl'; }
      if (box.innerHTML !== html) box.innerHTML = html;
      if (cnt.nextElementSibling !== box) cnt.insertAdjacentElement('afterend', box);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 150); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true, characterData: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 113 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    var M = { janvier: 'janv.', 'février': 'févr.', mars: 'mars', avril: 'avr.', mai: 'mai', juin: 'juin', juillet: 'juil.', 'août': 'août', septembre: 'sept.', octobre: 'oct.', novembre: 'nov.', 'décembre': 'déc.' };
    function sh(d) {
      var p = d.trim().toLowerCase().split(' ').filter(Boolean);
      if (p.length < 3) return d.trim();
      return p.join(' ');
    }
    var SHOP = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9l1.5-5h15L21 9M3 9h18M3 9v11h18V9M9 20v-6h6v6"/></svg>';
    function bar() {
      var dock = document.querySelector(C + ' > .pxl-dock');
      var fin = document.querySelector(C + ' .pxm-cfin');
      var b = dock ? dock.querySelector(':scope > .pxl-sdl') : null;
      if (!dock || !fin) { if (b) b.remove(); return; }
      var h = '';
      fin.querySelectorAll('.pxl-car-row').forEach(function (r) {
        var img = r.querySelector('img'), dt = r.querySelector('.pxl-car-date');
        if (img && dt) h += '<span>' + (img.getAttribute('src').indexOf('mondial') > -1 ? '<i class="pxl-sdl-mr"><img src="' + PXL_CFG.mr_logo_80 + '" alt="">Mondial Relay</i>' : '<i><img class="pxl-w" src="' + img.getAttribute('src') + '" alt="' + (img.getAttribute('alt') || '') + '"></i>') + sh(dt.textContent) + '</span>';
      });
      var once = fin.querySelector('.pxm-copt[data-mode="once"] .pxm-cod');
      if (once) { var d = once.textContent.trim(); if (d.indexOf('Tout ') === 0) d = d.slice(5); h = '<span><i class="pxl-sdl-shop">' + SHOP + 'Retrait</i>' + sh(d) + '</span>' + h; }
      if (!h) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'pxl-sdl'; }
      if (b.dataset.h !== h) { b.dataset.h = h; b.innerHTML = '<p class="pxl-sdl-t">Retrait magasin et livraison</p><div class="pxl-sdl-r">' + h + '</div>'; }
      if (b.parentNode !== dock) dock.insertBefore(b, dock.firstChild);
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; bar(); }, 160); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    bar();
  })();

/* ===== pxl-drawer-tweaks : script 125 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    function put() {
      var dock = document.querySelector(C + ' > .pxl-dock');
      var src = document.querySelector(C + ' > .pxm-cfoot > .pxl-rec .pxl-rec__bar');
      var cl = dock ? dock.querySelector(':scope > .pxl-urg-d') : null;
      if (!dock || !src) { if (cl) cl.remove(); return; }
      if (!cl) { cl = src.cloneNode(true); cl.classList.add('pxl-urg-d'); dock.appendChild(cl); }
    }
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 200); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 131 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart', OPEN = false;
    function put() {
      var f = document.querySelector(C + ' > .pxm-cfoot');
      var s = document.querySelector(C + ' > .pxm-clist > .pxl-ser');
      var p = f ? f.querySelector(':scope > .pxl-ser-pnl') : null;
      if (!f || !s) { if (p) p.remove(); if (f) f.classList.remove('pxl-pnl-on'); OPEN = false; return; }
      if (!p) {
        p = document.createElement('div'); p.className = 'pxl-ser pxl-ser-pnl';
        p.setAttribute('role', 'dialog'); p.setAttribute('aria-label', 'Pack Sérénité');
        p.innerHTML = '<div class="pxl-pnl-hero"><img src="' + PXL_CFG.ser_hero + '" alt=""><button type="button" class="pxl-pnl-x" aria-label="Fermer">×</button><div class="pxl-pnl-ht"><b>Pack Sérénité</b><span>Votre matériel protégé plus longtemps, l’esprit tranquille</span></div></div><div class="pxl-pnl-b"></div>';
        f.appendChild(p);
      }
      var b = p.querySelector('.pxl-pnl-b'), h = s.innerHTML;
      if (p.dataset.h !== h) { p.dataset.h = h; b.innerHTML = h; }
      f.classList.toggle('pxl-pnl-on', OPEN);
      var d = document.querySelector(C + ' > .pxl-dock');
      if (d) { p.style.bottom = 'auto'; p.style.height = Math.max(200, Math.round(d.getBoundingClientRect().top - f.getBoundingClientRect().top)) + 'px'; }
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.pxl-ser-r .pxl-ser-tg')) { OPEN = true; put(); return; }
      if (e.target.closest('.pxl-ser-pnl .pxl-pnl-x')) { OPEN = false; put(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && OPEN) { OPEN = false; put(); } });
    var t = null;
    function later() { if (t) return; t = setTimeout(function () { t = null; put(); }, 160); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 137 ===== */
window.addEventListener('resize', function () { var b = document.querySelector('[class*="ai-minidrawer"] .pxm-cart > .pxm-cfoot'); if (b) b.setAttribute('data-pxl-rz', String(Date.now())); var x = document.createElement('i'); document.body.appendChild(x); x.remove(); });

/* ===== pxl-drawer-tweaks : script 141 ===== */
(function () {
    var C = '[class*="ai-minidrawer"] .pxm-cart';
    var P = {}, OPEN = null, SEL = null;
    var EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
    function eur(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.split('"').join('&quot;'); }
    function foot() { return document.querySelector(C + ' > .pxm-cfoot'); }
    function info(row) {
      var a = row.querySelector('a.pxm-cn') || row.querySelector('a.pxm-cth');
      if (!a || !a.getAttribute('href')) return null;
      var u = new URL(a.getAttribute('href'), location.origin);
      var h = u.pathname.split('/products/')[1];
      if (!h) return null;
      return { handle: h.split('/')[0], vid: Number(u.searchParams.get('variant')) || 0 };
    }
    function load(h) {
      if (!P[h]) P[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      return P[h];
    }
    function find(pr, sel) { return pr.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null; }
    function mark() {
      document.querySelectorAll(C + ' .pxl-eye').forEach(function (e) { e.classList.toggle('on', !!OPEN && e.dataset.h === OPEN.h && Number(e.dataset.v) === OPEN.vid); });
    }
    function eyes() {
      document.querySelectorAll(C + ' > .pxm-clist > .pxm-citem').forEach(function (row) {
        var m = row.querySelector(':scope > .pxm-cmeta'), inf = info(row);
        if (!m || !inf) return;
        var e = m.querySelector(':scope > .pxl-eye');
        if (e && e.dataset.h === inf.handle && Number(e.dataset.v) === inf.vid) return;
        load(inf.handle).then(function (p) {
          var ex = m.querySelector(':scope > .pxl-eye');
          if (!p || !p.variants) { if (ex) ex.remove(); return; }
          if (!ex) { ex = document.createElement('button'); ex.type = 'button'; ex.className = 'pxl-eye'; ex.title = 'Voir et personnaliser'; ex.setAttribute('aria-label', 'Voir et personnaliser'); ex.innerHTML = EYE; m.appendChild(ex); }
          ex.dataset.h = inf.handle; ex.dataset.v = inf.vid;
          mark();
        });
      });
    }
    function panel() {
      var f = foot();
      if (!f) return null;
      var p = f.querySelector(':scope > .pxl-qv-pnl');
      if (!p) { p = document.createElement('div'); p.className = 'pxl-qv-pnl'; p.setAttribute('role', 'dialog'); p.setAttribute('aria-label', 'Personnaliser l’article'); f.appendChild(p); }
      var d = document.querySelector(C + ' > .pxl-dock');
      if (d) { p.style.bottom = 'auto'; p.style.height = Math.max(200, Math.round(d.getBoundingClientRect().top - f.getBoundingClientRect().top)) + 'px'; }
      return p;
    }
    function label(s) {
      if (/RTX|GTX|Radeon|RX |Arc /i.test(s)) return 'Carte graphique';
      if (/Ryzen|Core |Intel|Xeon|Pentium|Athlon/i.test(s)) return 'Processeur';
      if (/^(Noir|Blanc|Gris|Rose|Bleu|Rouge|Vert|Violet|Argent)/i.test(s)) return 'Coloris';
      return 'Caractéristique';
    }
    function render() {
      var p = panel(), f = foot();
      if (!p || !OPEN) return;
      var pr = OPEN.p, cur = find(pr, SEL);
      var parts = pr.title.split(' — '), specs = parts[1] ? parts[1].split(' · ') : [];
      var img = (cur && cur.featured_image && cur.featured_image.src) || pr.featured_image || '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      var chip = document.querySelector(C + ' .pxl-chip b');
      var tag = cur && cur.compare_at_price > cur.price && chip ? chip.textContent : '';
      var h = '<div class="pxl-qv-hero">' + (tag ? '<span class="pxl-qv-tag">' + esc(tag) + '</span>' : '') + (img ? '<img src="' + esc(img) + '" alt="' + esc(pr.title) + '">' : '') + '<button type="button" class="pxl-qv-x" aria-label="Fermer">×</button></div>';
      h += '<div class="pxl-qv-b"><p class="pxl-qv-t">' + esc(pr.title) + '</p>';
      var ks = specs.map(function (s) { return '<div class="pxl-qv-k">' + label(s) + '<b>' + esc(s) + '</b></div>'; });
      if (/pc gamer/i.test(pr.type || '')) {
        ks.push('<div class="pxl-qv-k">Boîtier<b>' + esc(parts[0].replace('PC Gamer ', '')) + '</b></div>');
        ks.push('<div class="pxl-qv-k">Montage<b>Atelier d’Orléans</b></div>');
      }
      if (ks.length) h += '<div class="pxl-qv-ks">' + ks.join('') + '</div>';
      if (pr.variants.length > 1) pr.options.forEach(function (o, i) {
        h += '<div class="pxl-qv-ot">' + esc(o.name) + '</div><div class="pxl-qv-sw">';
        o.values.forEach(function (val) {
          var s = SEL.slice(); s[i] = val;
          var v = find(pr, s), on = val === SEL[i], diff = v && cur ? v.price - cur.price : 0, lab = '';
          if (!v || !v.available) lab = 'Indisponible';
          else if (!on && diff > 0) lab = '+ ' + eur(diff).replace(',00', '');
          else if (!on && diff < 0) lab = '− ' + eur(-diff).replace(',00', '');
          h += '<button type="button" class="' + (on ? 'sel' : '') + '" data-i="' + i + '" data-val="' + esc(val) + '"' + (!v || !v.available ? ' disabled' : '') + '>' + esc(val) + (lab ? '<small>' + lab + '</small>' : '') + '</button>';
        });
        h += '</div>';
      });
      if (pr.variants.length < 2 && pr.description) { var dd = document.createElement('div'); dd.innerHTML = pr.description; var tx = (dd.textContent || '').trim(); if (tx) h += '<p class="pxl-qv-d">' + esc(tx.length > 300 ? tx.slice(0, 300) + '…' : tx) + '</p>'; }
      h += '<a class="pxl-qv-link" href="/products/' + esc(OPEN.h) + (cur ? '?variant=' + cur.id : '') + '">Voir la fiche complète →</a></div>';
      h += '<div class="pxl-qv-f"><div class="pxl-qv-pr">' + (cur && cur.compare_at_price > cur.price ? '<s>' + eur(cur.compare_at_price) + '</s>' : '') + '<b>' + (cur ? eur(cur.price) : '—') + '</b></div>';
      h += pr.variants.length < 2 ? '</div>' : '<button type="button" class="pxl-qv-go"' + (!cur || !cur.available || cur.id === OPEN.vid ? ' disabled' : '') + '>Mettre à jour</button></div>';
      p.innerHTML = h;
      f.classList.add('pxl-qv-on');
      mark();
    }
    function closeSer() { var x = document.querySelector(C + ' > .pxm-cfoot.pxl-pnl-on > .pxl-ser-pnl .pxl-pnl-x'); if (x) x.click(); }
    function close() { OPEN = null; var f = foot(); if (f) f.classList.remove('pxl-qv-on'); mark(); }
    function open(h, vid) {
      closeSer();
      load(h).then(function (pr) {
        if (!pr) return;
        var v = pr.variants.filter(function (x) { return x.id === vid; })[0] || pr.variants[0];
        OPEN = { p: pr, h: h, vid: v.id }; SEL = v.options.slice();
        render();
      });
    }
    function update(btn) {
      var cur = OPEN && find(OPEN.p, SEL);
      if (!cur) return;
      var old = OPEN.vid;
      btn.disabled = true; btn.textContent = 'Mise à jour…';
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var line = (c.items || []).filter(function (it) { return it.variant_id === old; })[0];
        if (!line) throw new Error('ligne');
        var u = {}, ex = (c.items || []).filter(function (it) { return it.variant_id === cur.id; }).reduce(function (s, it) { return s + it.quantity; }, 0);
        u[line.key] = 0; u[cur.id] = ex + line.quantity;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) });
      }).then(function (r) {
        if (!r.ok) throw new Error('maj');
        close();
        var mc = document.querySelector('mini-cart-abjzzqlppuenpu2z3naigenblockb2128c6qgkpd4');
        if (mc && mc.refreshCart) mc.refreshCart(true); else location.reload();
      }).catch(function () { btn.disabled = false; btn.textContent = 'Réessayer'; });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('.pxl-eye');
      if (t) { e.preventDefault(); if (OPEN && OPEN.h === t.dataset.h && OPEN.vid === Number(t.dataset.v)) close(); else open(t.dataset.h, Number(t.dataset.v)); return; }
      if (e.target.closest('.pxl-qv-x')) { close(); return; }
      var b = e.target.closest('.pxl-qv-sw button');
      if (b && OPEN) { SEL[Number(b.dataset.i)] = b.dataset.val; render(); return; }
      var g = e.target.closest('.pxl-qv-go');
      if (g && OPEN) { update(g); return; }
      if (e.target.closest('.pxl-ser-r .pxl-ser-tg') && OPEN) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && OPEN) close(); });
    function put() {
      eyes();
      if (OPEN) { var f = foot(); if (f && (!f.querySelector(':scope > .pxl-qv-pnl') || !f.classList.contains('pxl-qv-on'))) render(); else panel(); }
    }
    var tm = null;
    function later() { if (tm) return; tm = setTimeout(function () { tm = null; put(); }, 160); }
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    put();
  })();

/* ===== pxl-drawer-tweaks : script 143 ===== */
window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var f = document.querySelector('[class*="ai-minidrawer"] .pxm-cart > .pxm-cfoot');
    if (!f) return;
    var x = f.classList.contains('pxl-qv-on') ? f.querySelector('.pxl-qv-pnl .pxl-qv-x') : (f.classList.contains('pxl-pnl-on') ? f.querySelector('.pxl-ser-pnl .pxl-pnl-x') : null);
    if (!x) return;
    e.preventDefault(); e.stopImmediatePropagation(); x.click();
  }, true);